import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Suikoden II Best Ending" mdxType="SEO" />
    <h2 {...{
      "id": "suikoden-ii-best-ending-speedrun-notes"
    }}>{`Suikoden II Best Ending Speedrun notes`}</h2>
    <p>{`These notes are only meant for our RPGLB2024 run! Use the other ones.`}</p>
    <p>{`Soft reset buttons are L3+R3`}<br parentName="p"></br>{`
`}{`Turbo X is hold R1+X`}<br parentName="p"></br>{`
`}{`Turb Triangle is hold R1+Triangle`}</p>
    <p>{`DO NOT press L1+Select+Up, this turns on speed up.`}</p>
    <h3 {...{
      "id": "main-menu"
    }}>{`Main Menu`}</h3>
    <p>{`Use name from incentive.`}<br parentName="p"></br>{`
`}{`Load S1 Data from Memory Card 2`}<br parentName="p"></br>{`
`}{`Start timer on pressing yes to confirm save file selection.`}</p>
    <h3 {...{
      "id": "tenzan-pass"
    }}>{`Tenzan Pass`}</h3>
    <p><em parentName="p">{`"So anyway... should we go to sleep soon?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Set text speed to Fast`}</p>
    <p><strong parentName="p">{`4 Highland Soldier`}</strong><br parentName="p"></br>{`
`}{`Unite then auto`}</p>
    <h4 {...{
      "id": "after-first-battle"
    }}>{`After first battle`}</h4>
    <p><em parentName="p">{`"Hero, there is no other way."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`"Promise me, Hero"`}</em>{` Option 1`}</p>
    <h3 {...{
      "id": "mercenary-fort"
    }}>{`Mercenary Fort`}</h3>
    <p>{`Blacksmith `}<strong parentName="p">{`Option 3`}</strong>{` then Flint acquired text + 1 textbox`}<br parentName="p"></br>{`
`}{`Barbara `}<strong parentName="p">{`Option 3`}</strong>{` then Boots acquired text + 1 textbox`}<br parentName="p"></br>{`
`}{`Shopkeeper Just 1 Textbox careful mashing here`}</p>
    <h3 {...{
      "id": "world-map"
    }}>{`World Map`}</h3>
    <p>{`Appear above fort`}</p>
    <h3 {...{
      "id": "ryube"
    }}>{`Ryube`}</h3>
    <p>{`Go to shop`}</p>
    <h3 {...{
      "id": "mercenary-fort-1"
    }}>{`Mercenary Fort`}</h3>
    <p>{`Talk to Oil spills from top right except Flik's room bottom right`}</p>
    <p><strong parentName="p">{`After Jowy rescue`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`Flik > "That's far enough", Jowy > "We... we're outnumbered."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`Flik > Viktor > Jowy "Well that's..." > Viktor "What the hell happened?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "world-map-1"
    }}>{`World Map`}</h3>
    <p>{`Start below Mercenary Fort`}</p>
    <h3 {...{
      "id": "ryube-1"
    }}>{`Ryube`}</h3>
    <p><em parentName="p">{`Eilie > "Here we go!"`}</em>{` Knife-Throwing `}<strong parentName="p">{`Option 2 or 3`}</strong></p>
    <h4 {...{
      "id": "formation"
    }}>{`Formation`}</h4>
    <ol>
      <li parentName="ol">{`Hero > Rina`}</li>
      <li parentName="ol">{`Bolgan > Jowy`}</li>
    </ol>
    <h3 {...{
      "id": "north-sparrow-pass"
    }}>{`North Sparrow Pass`}</h3>
    <p>{`Pickup Fire Wall`}<br parentName="p"></br>{`
`}{`Heal and equip for Mist Monster`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Rina needs 37HP, Eilie needs 42HP. Assuming lowest possible DEF stats`}</p>
      </blockquote>
      <h5 {...{
        "id": "rina"
      }}>{`Rina`}</h5>
      <ul>
        <li parentName="ul">{`Best Equip`}</li>
        <li parentName="ul">{`Angry Blow > Jowy's Boots (l 2d X)`}</li>
        <li parentName="ul">{`Medicine > Hero's Boots (l u X)`}</li>
      </ul>
      <h5 {...{
        "id": "bolgan"
      }}>{`Bolgan`}</h5>
      <ul>
        <li parentName="ul">{`Jizo > Medicine`}</li>
      </ul>
      <h5 {...{
        "id": "eilie"
      }}>{`Eilie`}</h5>
      <ul>
        <li parentName="ul">{`Medicine > Firewall`}</li>
      </ul>
      <h5 {...{
        "id": "hero"
      }}>{`Hero`}</h5>
      <ul>
        <li parentName="ul">{`Medicine Slot 3 > Flaming Arrows`}</li>
        <li parentName="ul">{`Gloves > Jowy's Medicine or Flaming Arrows (l d X) `}<em parentName="li">{`Flaming Arrows for safe Mist Monster`}</em></li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`The slot might matter for Best Equip in Ryube Forest, not confirmed.`}</p>
    </blockquote>
    <h4 {...{
      "id": "mist-monster-800hp"
    }}>{`Mist Monster (800HP)`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Turn 1`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Turn 2`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Rina: Flaming Arrows`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Rina: Circus Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Bolgan: Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bolgan: Circus`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Eilie: Fire Wall`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Eilie: Circus`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hero: Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hero: Flaming Arrows`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Jowy: Angry Blow`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Jowy: Angry Blow`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "kyaro"
    }}>{`Kyaro`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Mukumuku`}</strong>{`.`}</p>
    <p><strong parentName="p">{`Soldier Fight`}</strong><br parentName="p"></br>{`
`}{`Hero: Flaming Arrow`}</p>
    <blockquote>
      <p parentName="blockquote">{`Watch Hero SPD here, and Hero MGC if he has both Flaming Arrow scrolls.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`If you got a Hazy Crystal drop, you will need to get rid of Gloves for RU SPD Glitch too.`}<br parentName="p"></br>{`
`}{`If Riou still has a Flaming Arrow scroll on him, ignore the above.`}</p>
    </blockquote>
    <p><em parentName="p">{`Viktor: "Damn, he ran away!", Jowy: "Wait, wait a minute."`}</em>{` `}<strong parentName="p">{`Option 2x3`}</strong></p>
    <h3 {...{
      "id": "mercenary-fort-2"
    }}>{`Mercenary Fort`}</h3>
    <p>{`Exit right away`}</p>
    <h3 {...{
      "id": "world-map-2"
    }}>{`World Map`}</h3>
    <p>{`Appear below Mercenary Fort, hold down then left`}</p>
    <h3 {...{
      "id": "toto"
    }}>{`Toto`}</h3>
    <hr></hr>
    <p><strong parentName="p">{`Save after getting points.`}</strong></p>
    <hr></hr>
    <p>{`Talk to the innkeeper 17 times and exit Toto `}<em parentName="p">{`talk to left side of book`}</em></p>
    <p>{`After leaving Pilika's house can hold left, won't run into girl.`}</p>
    <h3 {...{
      "id": "muse"
    }}>{`Muse`}</h3>
    <h4 {...{
      "id": "shop"
    }}>{`Shop`}</h4>
    <p><em parentName="p">{`Jowy:"What should we do?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h5 {...{
      "id": "buy"
    }}>{`Buy`}</h5>
    <ul>
      <li parentName="ul">{`Escape Talisman`}</li>
      <li parentName="ul">{`2 Antitoxin`}</li>
    </ul>
    <h3 {...{
      "id": "toto--world-map--mercenary-fort"
    }}>{`Toto > World Map > Mercenary Fort`}</h3>
    <h4 {...{
      "id": "blacksmith"
    }}>{`Blacksmith`}</h4>
    <p>{`Sharpen Hero's Weapon to 3`}<br parentName="p"></br>{`
`}{`Flik gives you 2k, Apple, Jowy: "Let's go, Hero." > `}<em parentName="p">{`Walk around Flik`}</em></p>
    <h3 {...{
      "id": "ryube-forest"
    }}>{`Ryube Forest`}</h3>
    <p><em parentName="p">{`If Safe Mist Monster, give Riou's Flaming Arrow to Jowy`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`If Riou has 22MGC (71.5%), he can do Flaming Arrows and kill the Slugs`}</em><br parentName="p"></br>{`
`}{`Pick up nest for Kinnison & Shiro.`}</p>
    <p>{`Need to kill either a 5x Spider battle or 3x Slug battle`}</p>
    <p>{`3 Slug:   Jowy Flaming Arrow`}<br parentName="p"></br>{`
`}{`5 Spider: Buddy Attack twice`}</p>
    <p><em parentName="p">{`After the battle try to check Hero & Jowy's speed. Want Jowy to be faster.`}</em></p>
    <p>{`Pick up 2 Chests in top left corner.`}</p>
    <h4 {...{
      "id": "equipment"
    }}>{`Equipment`}</h4>
    <p><strong parentName="p">{`Hero`}</strong><br parentName="p"></br>{`
`}{`Best Equip x2`}</p>
    <p>{`You can add Tsai to party if you already got a level up battle. Otherwise, Convoy.`}</p>
    <p>{`After Ryube is burned down `}<em parentName="p">{`Tsai, Jowy, Tsai`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "mercenary-fort-3"
    }}>{`Mercenary Fort`}</h3>
    <p>{`Heal Hero if he's not full HP`}</p>
    <hr></hr>
    <ul>
      <li parentName="ul">{`Save before duel.`}</li>
      <li parentName="ul">{`Ask about naming incentive.`}</li>
      <li parentName="ul">{`After duel, use name from naming incentive.`}</li>
    </ul>
    <hr></hr>
    <p><em parentName="p">{`Meeting room`}</em>{` After Jowy and Pilika come inside you `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "flik-duel"
    }}>{`Flik Duel`}</h4>
    <p><em parentName="p">{`Header is your action`}</em></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Attack`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Defend`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Wild Attack`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`C'mon take a swing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Here goes! Hope you can`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Nice try, I'll go`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Don't get too confident`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Here it comes. Better`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, let's see`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, it's your turn`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, maybe I should show`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whoa, nice strike`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`One more time. Don't`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`You dodged my sword,`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes, good. What'll`}</td>
        </tr>
      </tbody>
    </table>
    <p><em parentName="p">{`Jowy: "What should we do?"`}</em>{` `}<strong parentName="p">{`Name Army`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`Viktor: "Are you two ready?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "war-battle-1"
    }}>{`War Battle #1`}</h3>
    <h4 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h4>
    <p>{`1 Textbox then Select > End Turn`}</p>
    <h4 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h4>
    <p>{`Menu > End Turn`}</p>
    <h3 {...{
      "id": "war-battle-2"
    }}>{`War Battle #2`}</h3>
    <p><em parentName="p">{`Viktor, Flik, Viktor`}</em>{` `}<strong parentName="p">{`Option 2`}</strong>{` to start`}</p>
    <h4 {...{
      "id": "turn-1-3"
    }}>{`Turn 1-3`}</h4>
    <p>{`Want to move 2 down, will spawn soldier inside fort.`}</p>
    <h3 {...{
      "id": "mercenary-fort-4"
    }}>{`Mercenary Fort`}</h3>
    <p>{`If Jowy SPD == Hero SPD formation swap Hero & Jowy`}</p>
    <p><strong parentName="p">{`2x 4 Soldier Battle`}</strong><br parentName="p"></br>{`
`}{`Flaming Arrow if you have it otherwise Buddy Attack`}<br parentName="p"></br>{`
`}<em parentName="p">{`If using Flaming Arrow and Jowy is faster Hero attack otherwise Hero Defend`}</em></p>
    <h3 {...{
      "id": "world-map--toto"
    }}>{`World Map > Toto`}</h3>
    <p>{`Recruit Hanna`}<br parentName="p"></br>{`
`}{`Mash through cutscene`}</p>
    <h3 {...{
      "id": "muse-1"
    }}>{`Muse`}</h3>
    <p>{`If you swapped Jowy & Hero at fort don't change formation. Otherwise,`}</p>
    <h4 {...{
      "id": "formation-1"
    }}>{`Formation`}</h4>
    <p>{`Hero > Jowy`}<br parentName="p"></br>{`
`}{`Hero > Gengen`}</p>
    <h3 {...{
      "id": "white-deer-inn"
    }}>{`White Deer Inn`}</h3>
    <p><em parentName="p">{`Alex "...Hmmm", Alex checks you out, "Okay. I'll make you an offer."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <hr></hr>
    <p>{`Save after Alex joins`}</p>
    <hr></hr>
    <h3 {...{
      "id": "sindar-ruins"
    }}>{`Sindar Ruins`}</h3>
    <p>{`Pick Fire Lizard (screen to left of second plate).`}</p>
    <p>{`Level up battles are 5 MegaWatt or 4 Salamander`}<br parentName="p"></br>{`
`}{`Both Shining Light 1st turn, Jowy Defend.`}</p>
    <p>{`5 Megawatt, all attack so you don't Defend.`}<br parentName="p"></br>{`
`}{`4 Salamander, Nanami and Jowy Shift, rest Attack.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you fail a fight and use your Shining Light, you can still take a 5 MegaWatt fight by using Buddy attack instead.`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Hero`}</strong>{`: Remove everything, attach 1 Medicine`}</li>
        <li parentName="ul"><strong parentName="li">{`Nanami`}</strong>{`: Remove Feathered Cap`}</li>
        <li parentName="ul"><strong parentName="li">{`Gengen`}</strong>{`: Remove Leather Coat (optional)`}</li>
        <li parentName="ul"><strong parentName="li">{`Jowy`}</strong>{`: Best Equip, `}<strong parentName="li">{`Sacrificial Jizo`}</strong></li>
      </ul>
    </Menu>
    <p>{`Pick up Chainmail, Best Equip Jowy`}</p>
    <h4 {...{
      "id": "double-head-2500hp"
    }}>{`Double Head (2500HP)`}</h4>
    <h5 {...{
      "id": "turn-1-3-1"
    }}>{`Turn 1-3`}</h5>
    <p>{`Jowy Best Magic`}</p>
    <h3 {...{
      "id": "muse-2"
    }}>{`Muse`}</h3>
    <p>{`Trigger Elza Cutscene`}</p>
    <h4 {...{
      "id": "blacksmith-1"
    }}>{`Blacksmith`}</h4>
    <p>{`Fire Lizard > Hero`}</p>
    <p>{`Viktor joins before Annabelle `}<em parentName="p">{`don't change formation`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`Jess, Jowy walks forward "What do you think?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go back to inn, don't bring anyone.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-2"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Swap 1st Character and Jowy`}</li>
      </ul>
    </Menu>
    <h2 style={{
      color: 'red',
      fontSize: '36px',
      fontWeight: 700
    }}>Re-enter inn, get point/s for Anita!</h2>
    <hr></hr>
    <p>{`Save after getting Anita point`}</p>
    <hr></hr>
    <h3 {...{
      "id": "muse-highland-border"
    }}>{`Muse-Highland Border`}</h3>
    <p>{`Talk to right guard, then talk to him again.`}</p>
    <p>{`Kill Hero & Nanami on a rabbit battle.`}<br parentName="p"></br>{`
`}{`Do menu below after entering Highland camp, before forced battle.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Can do this menu before entering camp and Medicine Nanami, for better 6 Soldier fight odds`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-2"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Jowy`}</strong>{`: Remove Feathered Cap, Chainmail`}</li>
        <li parentName="ul"><strong parentName="li">{`Hero`}</strong>{`: Best Equip, Optionally swap Riou's Accessories for Jowy's.`}</li>
      </ul>
    </Menu>
    <p>{`First battle Riou attack, Jowy Defend. T2 Jowy Twinkling Blade.`}</p>
    <p>{`Second battle Hero Medicine self, Nanami Defend`}<br parentName="p"></br>{`
`}{`T2 / when Nanami dies Shining Light`}</p>
    <p><strong parentName="p">{`Option 2`}</strong>{` to trigger another battle, Shining Light.`}</p>
    <h3 {...{
      "id": "muse-3"
    }}>{`Muse`}</h3>
    <p>{`Go to Town Hall, then Inn`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Re-enter inn, get point/s for Anita!`}</strong></p>
    <p>{`Town Hall, then Inn`}<br parentName="p"></br>{`
`}{`Exit Muse `}<em parentName="p">{`Nanami 2 textboxes`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <p><strong parentName="p">{`Recruit Anita`}</strong><br parentName="p"></br>{`
`}{`If you didn't get enough points, save & soft reset.`}</p>
    <p>{`Go to Jowston Hill`}<br parentName="p"></br>{`
`}{`At Inn `}<em parentName="p">{`Jowy, Annabelle, Jowy`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <hr></hr>
    <p>{`Save before starting the War Battle`}</p>
    <hr></hr>
    <p>{`Talk to Viktor Option 1`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you have to soft reset at any point for Gilbert / Rose Brooch / Anita, you need to hold on to the top 3 items in your inventory instead of Bandanna / Robe / Gloves.`}<br parentName="p"></br>{`
`}{`The order is: Medicine, Mega Medicine, Antitoxin, Kindness Drops, Jizo, Bandanna, ...`}<br parentName="p"></br>{`
`}{`If unsure, just check inventory after reset. The order goes Inventory, Party, Storage.`}</p>
    </blockquote>
    <h3 {...{
      "id": "war-battle-3"
    }}>{`War Battle #3`}</h3>
    <p>{`End Turn every turn`}<br parentName="p"></br>{`
`}{`Can move Riou up for Bright Shield if on Gilbert if you want to be really safe.`}<br parentName="p"></br>{`
`}{`Battle ends when you end your turn after Knights retreat`}</p>
    <h3 {...{
      "id": "muse-4"
    }}>{`Muse`}</h3>
    <p>{`Talk to Nanami `}<em parentName="p">{`1 textbox "Hey Hero..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to Town Hall then Inn`}<br parentName="p"></br>{`
`}{`Inn 2nd Floor talk to Nanami `}<em parentName="p">{`1 textbox "Hey Hero..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go to Town Hall then Exit Muse`}</p>
    <h3 {...{
      "id": "coronet"
    }}>{`Coronet`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Rikimaru`}</strong>{` 2, 1, 2, 2`}</p>
    <hr></hr>
    <p>{`Save before Tai Ho`}</p>
    <hr></hr>
    <p>{`Go to southwest dock, Inn top floor, then Tai Ho`}<br parentName="p"></br>{`
`}{`Go to inn & get Circus crew. Watch Eilie Magic stat. Go to Tai Ho.`}</p>
    <h3 {...{
      "id": "kuskus"
    }}>{`Kuskus`}</h3>
    <p>{`Talk to NPC for Oulan`}</p>
    <h3 {...{
      "id": "south-window"
    }}>{`South Window`}</h3>
    <p>{`On entrance `}<em parentName="p">{`Viktor, Eilie`}</em>{` `}<strong parentName="p">{`Option 3`}</strong>{` `}<em parentName="p">{`Viktor, Pilika`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Pick up `}<strong parentName="p">{`Friendship Rune`}</strong>{` (4th plant from left). Go to Town Hall.`}</p>
    <p>{`After cutscenes go to Armor Shop.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You want 24250 after selling.`}<br parentName="p"></br>{`
`}{`Need 6200 for below to give enough money, if short can sell accessories & Brass Armor.`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Riou`}</strong>{`: Chainmail`}</li>
        <li parentName="ul"><strong parentName="li">{`Viktor`}</strong>{`: Half Helmet, Chainmail`}</li>
        <li parentName="ul"><strong parentName="li">{`Flik`}</strong>{`: Circuret, Leather Armor, Steel Shield`}</li>
        <li parentName="ul"><strong parentName="li">{`Freed`}</strong>{`: Circuret`}</li>
        <li parentName="ul">{`If still short: accessories, Freed's Brass Armor, junk from inventory.`}</li>
      </ul>
    </Menu>
    <p>{`Go to Trading Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`All Mayonnaise`}</li>
        <li parentName="ul">{`All Native Costumes`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Track the amount of Mayonnaise and Native Costumes you buy from your South Window trading trips.`}</p>
      </blockquote>
    </Menu>
    <p>{`Go back to inn. Can check Eilie's magic when she joins if you missed it earlier.`}<br parentName="p"></br>{`
`}{`Go to Rune Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-2"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`3 Lightning Crystal`}</li>
      </ul>
      <h5 {...{
        "id": "attach"
      }}>{`Attach`}</h5>
      <ul>
        <li parentName="ul">{`Lightning > Riou (Head)`}</li>
        <li parentName="ul">{`Lightning > Eilie`}</li>
        <li parentName="ul">{`Spark > Nanami`}</li>
      </ul>
    </Menu>
    <p>{`Head to North Window`}</p>
    <h3 {...{
      "id": "north-window"
    }}>{`North Window`}</h3>
    <p><em parentName="p">{`Nanami runs behind you, Neclord 2 textboxes.`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "cave-of-the-wind"
    }}>{`Cave of the Wind`}</h3>
    <p>{`Pick up Blue Gate & 3000 potch `}<em parentName="p">{`Top two chests`}</em></p>
    <blockquote>
      <p parentName="blockquote">{`Before you get Kahn, if you’re 56-58 MGC on Eilie you can take a 4 Minotaur fight. It only saves you time if you get a Bolt for both boss fights and you wouldn’t have had it for either without the Minotaur fight.`}</p>
    </blockquote>
    <p><em parentName="p">{`Kahn, Viktor sweat animation, Kahn "So may I..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-3"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Nanami > Eilie`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-3"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Freed: Remove Wooden Shield (Unless you removed Gengen's earlier.)`}</li>
        <li parentName="ul">{`Freed's Medicine > Khan's Firewall x3 (X l d X)`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "star-dragon-sword-2500hp"
    }}>{`Star Dragon Sword (2500HP)`}</h4>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Thor Shot`}</li>
      <li parentName="ul">{`Eilie: Defend / Bolt of Wrath`}</li>
      <li parentName="ul">{`Viktor: Attack`}</li>
      <li parentName="ul">{`Freed: Defend / Firewall`}</li>
      <li parentName="ul">{`Nanami: Defend / Attack`}</li>
      <li parentName="ul">{`Kahn: Charm Arrow`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Bolt of Wrath`}</li>
      <li parentName="ul">{`Eilie: Defend`}</li>
      <li parentName="ul">{`Viktor: Attack`}</li>
      <li parentName="ul">{`Freed: Defend`}</li>
      <li parentName="ul">{`Nanami: Attack`}</li>
      <li parentName="ul">{`Kahn: Attack`}</li>
    </ul>
    <p>{`Run back to Kuskus`}</p>
    <h3 {...{
      "id": "kuskus-1"
    }}>{`Kuskus`}</h3>
    <p>{`Stay at inn`}<br parentName="p"></br>{`
`}{`Go to Blacksmith`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "embed"
      }}>{`Embed`}</h5>
      <ul>
        <li parentName="ul">{`Friendship > Hero`}</li>
        <li parentName="ul">{`Fire Lizard > Nanami`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "north-window-1"
    }}>{`North Window`}</h3>
    <h4 {...{
      "id": "abomination-4500hp"
    }}>{`Abomination (4500HP)`}</h4>
    <h5 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Thor Shot`}</li>
      <li parentName="ul">{`Eilie: Defend / Bolt of Wrath`}</li>
      <li parentName="ul">{`Viktor: Attack`}</li>
      <li parentName="ul">{`Freed: Firewall`}</li>
      <li parentName="ul">{`Nanami: Attack`}</li>
      <li parentName="ul">{`Kahn: Charm Arrow`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If you have Bolt only need Nanami Attack + Riou Bolt of Wrath T2. With Viktor miss/defend need about 30 damage more.`}<br parentName="p"></br>{`
`}{`Eilie Defend guarantees her survival. If she doesn't have Bolt, she needs to live so she can get it for Pest Rat.`}<br parentName="p"></br>{`
`}{`An Eilie attack would fill the damage enough that you can have Kahn Attack with 1 Viktor hit.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Bolt of Wrath`}</li>
      <li parentName="ul">{`Eilie: Thunder Runner`}</li>
      <li parentName="ul">{`Viktor: Attack`}</li>
      <li parentName="ul">{`Freed: Fire Wall`}</li>
      <li parentName="ul">{`Nanami: Attack`}</li>
      <li parentName="ul">{`Kahn: Scolding (Can Attack but needs both Viktor hits)`}</li>
    </ul>
    <h3 {...{
      "id": "castle"
    }}>{`Castle`}</h3>
    <p><em parentName="p">{`Viktor: "But...", Flik, Tsai, Rina: "..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to Radat`}</p>
    <h3 {...{
      "id": "radat"
    }}>{`Radat`}</h3>
    <p>{`Tavern after Shu leaves Apple `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Richmond `}<strong parentName="p">{`Option 2`}</strong>{` then Option 1`}</p>
    <p>{`Sluice Gate `}<strong parentName="p">{`Option 2 x3`}</strong></p>
    <h4 {...{
      "id": "amada-duel-1"
    }}>{`Amada Duel #1`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Attack`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Defend`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Wild Attack`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Dammit!!! I might lose`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Argh! I'll get ya next`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ARGH!!!!.....`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Damn! Dammit!!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, boy, here`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, first a little`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`He he, first show me`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, it's my turn next!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ouch!!! I definitely`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I won't fall for that`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Way to go, kid!!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "castle-1"
    }}>{`Castle`}</h3>
    <p><strong parentName="p">{`Option 2`}</strong>{` to lead battle`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "war-battle-4"
    }}>{`War Battle #4`}</h3>
    <p><strong parentName="p">{`Turn 1`}</strong><br parentName="p"></br>{`
`}{`State Soldier Wait`}<br parentName="p"></br>{`
`}{`Hero Repair Self / Bright Shield`}<br parentName="p"></br>{`
`}<em parentName="p">{`You get ~1:40 break here unless a unit with with death dialogue dies`}</em></p>
    <blockquote>
      <p parentName="blockquote">{`This is a new strat. Turns out using Repair Self / Bright Shield triggers the Solon Jhee event`}</p>
    </blockquote>
    <p><strong parentName="p">{`Turn 2 & on`}</strong><br parentName="p"></br>{`
`}{`Move State Soldier out of Solon Jhee's range`}</p>
    <h3 {...{
      "id": "castle-2"
    }}>{`Castle`}</h3>
    <hr></hr>
    <p>{`Ask for Castle Name Incentive`}</p>
    <hr></hr>
    <p>{`Go to Bed, Nanami, `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to Great Hall`}<br parentName="p"></br>{`
`}{`Name Castle after Eilie talks`}</p>
    <p>{`Go to Castle entrance, Fitcher `}<strong parentName="p">{`Option 2`}</strong>{`, 1`}</p>
    <p>{`Great Hall `}<em parentName="p">{`Flik, Fitcher, Flik`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to Kuskus`}</p>
    <h3 {...{
      "id": "kuskus-2"
    }}>{`Kuskus`}</h3>
    <hr></hr>
    <p>{`Save before Tai Ho`}</p>
    <hr></hr>
    <p>{`Recruit `}<strong parentName="p">{`Tai Ho & Yam Koo`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Oulan`}</strong>{`. Go left to exit Kuskus.`}</p>
    <p>{`Go back to Castle.`}</p>
    <h3 {...{
      "id": "castle-3"
    }}>{`Castle`}</h3>
    <p>{`Go to Tavern, talk to Leona.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Add Eilie (d)`}</li>
        <li parentName="ul">{`Tai Ho (r d)`}</li>
        <li parentName="ul">{`Luc (u)`}</li>
      </ul>
    </Menu>
    <p>{`Go to meeting room.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-1"
      }}>{`Party`}</h5>
      <p>{`Don't change.`}</p>
      <h5 {...{
        "id": "formation-4"
      }}>{`Formation`}</h5>
      <p>{`Riou > Nanami`}</p>
    </Menu>
    <p>{`Take boat to Lakewest.`}</p>
    <h3 {...{
      "id": "lakewest--two-river"
    }}>{`Lakewest > Two River`}</h3>
    <p>{`In Winger Section: Chase Chaco x2, go to Item Shop`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-need-600-potch"
      }}>{`Sell (Need 600 potch)`}</h5>
      <ul>
        <li parentName="ul">{`Everything in inventory `}<strong parentName="li">{`EXCEPT`}</strong></li>
        <li parentName="ul">{`Sacrificial Jizo`}</li>
        <li parentName="ul">{`Stuff for RU SPD Glitch`}</li>
        <li parentName="ul">{`Wooden Shield`}</li>
        <li parentName="ul">{`Lightning & Blue Gate Runes`}</li>
        <li parentName="ul"><em parentName="li">{`Can sell Oulan's Half Helmet & Chain Mail if you want extra money`}</em></li>
      </ul>
    </Menu>
    <p>{`Leave shop, continue left path, chase Chaco x3. Then go back around and finish the chase.`}</p>
    <p>{`Fitcher skip: Walk 1 step right, then run down, then right to bounce off wall.`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Hans`}</strong>{`.`}</p>
    <p>{`Ridley and Makai fighting `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Makai asks for help `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go to Rune Shop`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "attach-1"
      }}>{`Attach`}</h5>
      <ul>
        <li parentName="ul">{`Lightning > Luc, over Pixie`}</li>
        <li parentName="ul">{`Blue Gate > Luc`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "sewer"
    }}>{`Sewer`}</h3>
    <p>{`Pick up Fire Emblem (Top chest)`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-4"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Eilie: Empty Accessory > Jizo`}</li>
        <li parentName="ul">{`Eilie: 2nd Accessory > Luc Bolt of Wrath (l 2d X)`}</li>
        <li parentName="ul">{`Nanami: Bandanna (X X) or Best Equip`}</li>
        <li parentName="ul">{`Riou: Feathered Hat > Nanami's Bandanna (X l X), Best Equip`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "pest-rat-5200hp"
    }}>{`Pest Rat (5200HP)`}</h4>
    <h5 {...{
      "id": "turn-1-4"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Nanami: Defend`}</li>
      <li parentName="ul">{`Hero: Thor Shot`}</li>
      <li parentName="ul">{`Oulan: Attack`}</li>
      <li parentName="ul">{`Luc: Thor Shot`}</li>
      <li parentName="ul">{`Eilie: Bolt of Wrath`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-3"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Nanami: Attack`}</li>
      <li parentName="ul">{`Hero: Bolt of Wrath`}</li>
      <li parentName="ul">{`Oulan: Attack`}</li>
      <li parentName="ul">{`Luc: Bolt of Wrath`}</li>
      <li parentName="ul">{`Eilie: Bolt of Wrath Scroll`}</li>
    </ul>
    <h3 {...{
      "id": "two-river"
    }}>{`Two River`}</h3>
    <p>{`Reinforcements `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`After Battle Option 2`}</strong>{` then Option 1, `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "lakewest"
    }}>{`Lakewest`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Kindness Rune`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Not holding L2 while talking to plant seems to help skip delay for Kindness rune.`}</p>
    </blockquote>
    <p>{`Go to Kuskus > South Window.`}</p>
    <h3 {...{
      "id": "south-window-1"
    }}>{`South Window`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Clive`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Zamza`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Alex & Hilda`}</strong>{`.`}</p>
    <p>{`Go to Trading Shop`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-3"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Mayonnaise`}</li>
        <li parentName="ul">{`Native Costume`}</li>
      </ul>
    </Menu>
    <p>{`Recruit `}<strong parentName="p">{`Adlai`}</strong>{`. `}<strong parentName="p">{`3rd time Option 2`}</strong></p>
    <h3 {...{
      "id": "castle-4"
    }}>{`Castle`}</h3>
    <p>{`Go to meeting room`}<br parentName="p"></br>{`
`}{`Go to dock & get on boat.`}</p>
    <p style={{
      color: 'red',
      fontSize: '36px',
      fontWeight: '700'
    }}>
Re-enter castle to upgrade Castle to level 2!
    </p>
    <h3 {...{
      "id": "lakewest-1"
    }}>{`Lakewest`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Kindness Rune`}</strong>{` if you haven't already.`}<br parentName="p"></br>{`
`}{`Go to Greenhill.`}</p>
    <h3 {...{
      "id": "greenhill"
    }}>{`Greenhill`}</h3>
    <p>{`Pick names after Fitcher leaves & Flik talks`}</p>
    <p><strong parentName="p">{`Recruit Emilia`}</strong>{`.`}</p>
    <p>{`Bedtime `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Bedtime `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Bedtime `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`First 2 Battles - Shining Light`}</p>
    <p><strong parentName="p">{`Go to Blacksmith after 1st 2 battles.`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sharpen"
      }}>{`Sharpen`}</h5>
      <ul>
        <li parentName="ul">{`Hero > 8`}</li>
      </ul>
      <h5 {...{
        "id": "embed-1"
      }}>{`Embed`}</h5>
      <ul>
        <li parentName="ul">{`Kindness > Nanami`}</li>
        <li parentName="ul"><em parentName="li"><strong parentName="em">{`Optional`}</strong>{` Fire Lizard > Flik. Let's him kill soldiers, costs 5700`}</em></li>
      </ul>
    </Menu>
    <p>{`Next 2 Battles Auto`}<br parentName="p"></br>{`
`}{`Next 2 Battles Shining Light`}<br parentName="p"></br>{`
`}{`Next 2 Battles Auto`}</p>
    <hr></hr>
    <p>{`Ask about Clive Incentive.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "two-river-1"
    }}>{`Two River`}</h3>
    <p>{`Go to Item Shop in Kobold District`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Want 64000 for most expensive Highway Village Trade Shop.`}<br parentName="p"></br>{`
`}{`Consider money you will lose to Shilo as well.`}</p>
      </blockquote>
      <h5 {...{
        "id": "sell-1"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Junk for money / inventory space (Keep anything needed for RU Glitch)`}</li>
        <li parentName="ul">{`Pixie`}</li>
        <li parentName="ul">{`Fire Lizard`}</li>
        <li parentName="ul">{`Poison`}</li>
        <li parentName="ul"><em parentName="li">{`Optional`}</em>{` sell Wakaba's Head Gear & Belt of Strength for money`}</li>
      </ul>
      <h5 {...{
        "id": "buy-4"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`2-3 Fried Tacos (94.2% - 98.6%)`}</li>
      </ul>
    </Menu>
    <p>{`Go to Rune Shop in Human District, recruit `}<strong parentName="p">{`Jeane`}</strong>{`.`}</p>
    <h3 {...{
      "id": "lakewest-2"
    }}>{`Lakewest`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "inventory"
      }}>{`Inventory`}</h5>
      <ul>
        <li parentName="ul">{`Use All Tacos`}</li>
      </ul>
    </Menu>
    <p>{`Recruit `}<strong parentName="p">{`Tetsu`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Taki`}</strong>{`.`}</p>
    <h3 {...{
      "id": "castle-5"
    }}>{`Castle`}</h3>
    <p>{`Go to Great Hall.`}<br parentName="p"></br>{`
`}{`Go back to bed.`}<br parentName="p"></br>{`
`}{`Go to Great Hall.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-2"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Nanami (u X)`}</li>
        <li parentName="ul">{`Luc (l X)`}</li>
        <li parentName="ul"><em parentName="li">{`If Incentive Met`}</em>{` Clive (r 2d X)`}</li>
        <li parentName="ul">{`Gengen (2r u X) / With Clive (r 2u X)`}</li>
      </ul>
      <h5 {...{
        "id": "formation-5"
      }}>{`Formation`}</h5>
      <p>{`Nanami > Slot 4 (Clive/Gengen)`}</p>
    </Menu>
    <p>{`Take boat to Lakewest.`}</p>
    <h6 {...{
      "id": "clive-sidequest-triggers"
    }}>{`Clive Sidequest Triggers:`}</h6>
    <ol>
      <li parentName="ol">{`Lakewest Inn: Man by counter`}</li>
      <li parentName="ol">{`Forest Village: Behind Trade Shop`}</li>
      <li parentName="ol">{`Rockaxe: Inn`}</li>
    </ol>
    <h3 {...{
      "id": "lakewest-3"
    }}>{`Lakewest`}</h3>
    <hr></hr>
    <p>{`Save before Shilo`}</p>
    <hr></hr>
    <p>{`Recruit `}<strong parentName="p">{`Shilo`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Start `}<strong parentName="p">{`Hix & Tengaar`}</strong>{` quest. (Talk to Hix twice from bottom.)`}</p>
    <h3 {...{
      "id": "two-river-2"
    }}>{`Two River`}</h3>
    <p>{`Recruit Jeane if you didn't earlier.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Recruit Gabocha`}</strong>{`.`}</p>
    <p>{`Head to Greenhill-Muse Border`}</p>
    <h3 {...{
      "id": "greenhill-muse-border"
    }}>{`Greenhill-Muse Border`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Meg & Gadget`}</strong>{`.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Forest Village`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "trading-guide"
      }}>{`Trading Guide`}</h5>
      <p>{`Syntax will be amount of Mayonnaise | amount of Native Costumes you've bought so far.`}<br parentName="p"></br>{`
`}{`For example, 6|5 means you have 6 Mayonnaise and 5 Native Costumes`}<br parentName="p"></br>{`
`}{`For simpler instructions, just follow the per-town Trade Shop instructions further down.`}</p>
      <h5 {...{
        "id": "universal-rules"
      }}>{`Universal Rules`}</h5>
      <ul>
        <li parentName="ul">{`Forest Village: Always buy 3 Native Costumes unless skipping Trade Shop.`}</li>
        <li parentName="ul">{`If buying Book(s), if 4 Books in stock buy all of them. You can then skip Gold Bar and Deer Antler purchases.`}</li>
        <li parentName="ul">{`You always sell everything on return trip through Highway Village.`}</li>
      </ul>
      <h5 {...{
        "id": "guide"
      }}>{`Guide`}</h5>
      <ul>
        <li parentName="ul">{`6|4: Buy 8 Sugar in Forest Village. Sell Sugar in 1st visit to Highway Village. Buy Book(s) in Highway Village.`}</li>
        <li parentName="ul">{`6|5: If Mayonnaise price high in Highway, buy Book(s) in Highway.`}</li>
        <li parentName="ul">{`8|4: Standard`}</li>
        <li parentName="ul">{`6|6: Standard. If Highway Village Mayonnaise low price, can skip buying Deer Antlers.`}</li>
        <li parentName="ul">{`8|5: Skip Forest Village Trade Shop, Buy Book(s) in Highway if Mayonnaise price is high.`}</li>
        <li parentName="ul">{`8|6, 10|4: Skip Forest Village Trade Shop`}</li>
        <li parentName="ul">{`10|5: Skip Forest Village Trade Shop, can skip Deer Antlers if Mayonnaise price is low.`}</li>
        <li parentName="ul">{`10|6: Skip Forest Village Trade Shop, skip Deer Antlers.`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "forest-village"
    }}>{`Forest Village`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Wakaba`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Tony`}</strong>{`.`}</p>
    <p>{`Go to Trade Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-5"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`3 Native Costume`}</li>
        <li parentName="ul">{`If only 6 Mayonnaise & 4 Native Costumes, buy 8 Sugar.`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Note that if you need to buy Sugar, you only have 2 slots available for random items.`}</p>
      </blockquote>
    </Menu>
    <p>{`Head to Greenhill-Matilda Border.`}</p>
    <h3 {...{
      "id": "greenhill-matilda-border"
    }}>{`Greenhill-Matilda Border`}</h3>
    <p>{`Viki Option 1 `}<strong parentName="p"><em parentName="strong">{`then Option 2`}</em></strong></p>
    <h3 {...{
      "id": "rockaxe"
    }}>{`Rockaxe`}</h3>
    <p>{`Camus refugee battle `}<strong parentName="p"><em parentName="strong">{`Option 3`}</em></strong></p>
    <p><strong parentName="p">{`Get Violence Rune`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Rune Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "attach-2"
      }}>{`Attach`}</h5>
      <ul>
        <li parentName="ul">{`Violence > Nanami (Over Spark)`}</li>
        <li parentName="ul">{`Spark > Riou Left Hand`}</li>
      </ul>
    </Menu>
    <p>{`Head to Highway Village.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "trading-guide-1"
      }}>{`Trading Guide`}</h5>
      <p>{`This is the same guide as the one above.`}<br parentName="p"></br>{`
`}{`For simpler instructions, just follow the per-town Trade Shop instructions further down.`}<br parentName="p"></br>{`
`}{`X|X refers to the amount of Mayonnaise / Native Costumes you had after the 2nd South Window Trade Shop. Purchases in Forest Village and Highway Village don't count.`}</p>
      <h5 {...{
        "id": "universal-rules-1"
      }}>{`Universal Rules`}</h5>
      <ul>
        <li parentName="ul">{`If buying Book(s), if 4 Books in stock buy all of them. You can then skip Gold Bar and Deer Antler purchases.`}</li>
        <li parentName="ul">{`You always sell everything on return trip through Highway Village.`}</li>
      </ul>
      <h5 {...{
        "id": "guide-1"
      }}>{`Guide`}</h5>
      <ul>
        <li parentName="ul">{`6|4: Buy 8 Sugar in Forest Village. Sell Sugar in 1st visit to Highway Village. Buy Book(s) in Highway Village.`}</li>
        <li parentName="ul">{`6|5: If Mayonnaise price high in Highway, buy Book(s) in Highway.`}</li>
        <li parentName="ul">{`8|4: Standard`}</li>
        <li parentName="ul">{`6|6: Standard. If Highway Village Mayonnaise low price, can skip buying Deer Antlers.`}</li>
        <li parentName="ul">{`8|5: Skip Forest Village Trade Shop, Buy Book(s) in Highway if Mayonnaise price is high.`}</li>
        <li parentName="ul">{`8|6, 10|4: Skip Forest Village Trade Shop`}</li>
        <li parentName="ul">{`10|5: Skip Forest Village Trade Shop, can skip Deer Antlers if Mayonnaise price is low.`}</li>
        <li parentName="ul">{`10|6: Skip Forest Village Trade Shop, skip Deer Antlers.`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "highway-village"
    }}>{`Highway Village`}</h3>
    <p>{`Go to Trade Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "situational"
      }}>{`Situational`}</h5>
      <ul>
        <li parentName="ul">{`Sell `}<strong parentName="li">{`Sugar`}</strong>{` if you bought it in Forest Village`}</li>
        <li parentName="ul"><em parentName="li">{`If 6|5 or worse`}</em>{`: Buy all Books (1 or 4)`}</li>
        <li parentName="ul"><em parentName="li">{`If you bought 4 Books, can skip buying Deer Antlers & Gold Bar`}</em></li>
      </ul>
      <h5 {...{
        "id": "buy-6"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Mayonnaise (Sell if high, ~2750)`}</li>
        <li parentName="ul">{`Native Costumes`}</li>
        <li parentName="ul">{`Deer Antlers`}</li>
        <li parentName="ul">{`Gold Bar`}</li>
      </ul>
      <p>{`Note the time you exit the dialogue with the trader. Do not talk to him again until approximately 12 minutes and 33 seconds have passed since this moment.`}</p>
      <blockquote>
        <p parentName="blockquote">{`Explanation: you need the amount of minutes IGT to advance by 12-14 between trades. That let's the trade shop refresh 4 times. Note that this doesn't consider seconds, so if you exited the dialogue at IGT 35 minutes 0 seconds, you would need to enter at 47 minutes 0 seconds. This takes approximately 12 minutes 33 seconds if you watch the Muse Wolf cutscene. If you exited at 35 minutes 59 seconds, you would need to enter at 47 minutes 0 seconds as well. This would let you enter 59 seconds faster, but there is no good way to track IGT so best to play it safe.`}</p>
      </blockquote>
    </Menu>
    <p>{`Go to Inn, talk to Humphrey. Talk to Humphrey again, go outside, talk to Humphrey, talk to innkeeper.`}<br parentName="p"></br>{`
`}{`Replace Gengen (& Clive).`}</p>
    <h3 {...{
      "id": "muse-matilda-border"
    }}>{`Muse-Matilda Border`}</h3>
    <p>{`Miklotov `}<strong parentName="p">{`Option 2`}</strong>{`, to Convoy`}</p>
    <blockquote>
      <p parentName="blockquote">{`You can add him to party and replace Gengen to get Let Go's on groups of 6 in Rakutei & Matilda. I don't think it's worth it though.`}</p>
    </blockquote>
    <h3 {...{
      "id": "muse-5"
    }}>{`Muse`}</h3>
    <p>{`Miklotov 2 textboxes then ~50 second cutscene break.`}</p>
    <h5 {...{
      "id": "soldier-fight"
    }}>{`Soldier fight`}</h5>
    <p>{`Hero Shining Light`}<br parentName="p"></br>{`
`}{`Head to Rakutei Mountain`}</p>
    <h3 {...{
      "id": "rakutei-mountain"
    }}>{`Rakutei Mountain`}</h3>
    <p>{`First 3 forks right, left, right.`}<br parentName="p"></br>{`
`}{`Next screen up, right, up, down.`}</p>
    <hr></hr>
    <p>{`Save before Harpy`}</p>
    <hr></hr>
    <h4 {...{
      "id": "harpy-7400hp"
    }}>{`Harpy (7400HP)`}</h4>
    <h5 {...{
      "id": "turn-1-5"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Attack`}</li>
      <li parentName="ul">{`Futch: Medicine Luc`}</li>
      <li parentName="ul">{`Luc: Empty World`}</li>
      <li parentName="ul">{`Nanami: Attack`}</li>
      <li parentName="ul">{`Humphrey: Mega Medicine Nanami`}</li>
      <li parentName="ul">{`Wakaba: Defend`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Take note of damage on Nanami. If needed, heal before Worm.`}<br parentName="p"></br>{`
`}{`Manual combat + Humphrey Mega Medicine Nanami is a good option, costs about 2s.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-2-4"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Auto`}</li>
    </ul>
    <h3 {...{
      "id": "highway-village-1"
    }}>{`Highway Village`}</h3>
    <p>{`Humprey & Futch recruited.`}<br parentName="p"></br>{`
`}{`Go to Trade Shop. After 12 minutes and 33 seconds have passed from exiting the previous trade dialogue, talk to the trader.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-2"
      }}>{`Sell`}</h5>
      <p>{`Everything`}</p>
    </Menu>
    <h3 {...{
      "id": "rockaxe--castle"
    }}>{`Rockaxe > Castle`}</h3>
    <p>{`Great Hall > Go to bed > Great Hall`}<br parentName="p"></br>{`
`}{`Talk to Apple.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "army-formation"
      }}>{`Army Formation`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Shu`}</strong>{` (Hero) > Ridley `}{`[OPTIONAL]`}</li>
        <li parentName="ul"><strong parentName="li">{`Humphrey`}</strong>{` > Hero (To RJ-proof war battles)`}</li>
        <li parentName="ul"><strong parentName="li">{`Tai Ho / Hanna`}</strong>{` > Ridley `}{`[OPTIONAL]`}</li>
        <li parentName="ul"><strong parentName="li">{`Adlai`}</strong>{` > Gilbert`}</li>
        <li parentName="ul"><strong parentName="li">{`Camus`}</strong>{` (Teresa) > Gilbert (if he doesn't have Cavalry already).`}</li>
        <li parentName="ul"><strong parentName="li">{`Chaco / Knight`}</strong>{` > Luc`}</li>
        <li parentName="ul"><strong parentName="li">{`Jeane`}</strong>{` > Hero`}</li>
      </ul>
    </Menu>
    <p>{`Teleport to Radat (3D)`}</p>
    <h3 {...{
      "id": "radat-1"
    }}>{`Radat`}</h3>
    <p>{`Option 1`}<br parentName="p"></br>{`
`}{`Re-enter Radat, `}<strong parentName="p">{`Option 2`}</strong>{`.`}</p>
    <h3 {...{
      "id": "castle-6"
    }}>{`Castle`}</h3>
    <h5 style={{
      fontSize: '36px',
      color: 'red'
    }}>
  RECRUIT Hai Yo
    </h5>
    <p><strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "war-battle"
    }}>{`War Battle`}</h3>
    <h5 {...{
      "id": "turn-1-6"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero - L`}</li>
      <li parentName="ul">{`Viktor (R1) - U`}</li>
      <li parentName="ul">{`Flik (R1) - UL`}</li>
      <li parentName="ul">{`Teresa (R1) - U`}</li>
      <li parentName="ul">{`Luc (R1) - 2L`}</li>
      <li parentName="ul">{`Ridley (R1) - Wait`}</li>
      <li parentName="ul">{`Gilbert (R1) 2L`}</li>
      <li parentName="ul">{`Kobold (R1) - U`}</li>
      <li parentName="ul">{`Kobold (R1) - U`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-5"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Hero - L`}</li>
      <li parentName="ul">{`Viktor (R1) - U`}</li>
      <li parentName="ul">{`Flik (R1) - 2L`}</li>
      <li parentName="ul">{`Teresa (R1) - U`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Viktor (R1) - L`}</li>
      <li parentName="ul">{`Teresa (Manual) - L`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Viktor (R1) - L | If in Enemy Attack Range`}</li>
      <li parentName="ul">{`Gilbert (Manual) - L | If in Enemy Attack Range`}</li>
    </ul>
    <h3 {...{
      "id": "castle-7"
    }}>{`Castle`}</h3>
    <p>{`Go to bed`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "kiba-war-battle"
    }}>{`Kiba War Battle`}</h3>
    <h5 {...{
      "id": "turns-1-5"
    }}>{`Turns 1-5`}</h5>
    <p>{`Move 3R1U`}</p>
    <h5 {...{
      "id": "turn-6"
    }}>{`Turn 6`}</h5>
    <ul>
      <li parentName="ul">{`Luc - Wind Magic`}</li>
      <li parentName="ul">{`Flik - Fire Spear (If Luc failed)`}</li>
      <li parentName="ul">{`Gilbert - DR`}</li>
    </ul>
    <h5 {...{
      "id": "turn-7"
    }}>{`Turn 7`}</h5>
    <ul>
      <li parentName="ul">{`Hero - U`}</li>
      <li parentName="ul">{`Gilbert - 2R`}</li>
      <li parentName="ul">{`Luc - Wind Magic (If Kiba < 2 damage)`}</li>
      <li parentName="ul">{`Flik - Fire Spear (If Kiba < 2 damage)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-8--on"
    }}>{`Turn 8 & on`}</h5>
    <p>{`Use Lightning, Invention, Wind Magic, and wing it after if it’s not over`}</p>
    <h3 {...{
      "id": "castle-8"
    }}>{`Castle`}</h3>
    <p>{`Kiba Option 1 then `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "castle-9"
    }}>{`Castle`}</h3>
    <p>{`Go to Tavern.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-3"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Nanami (r d2)`}</li>
        <li parentName="ul">{`Freed (r2 d)`}</li>
        <li parentName="ul">{`Luc (r d2)`}</li>
      </ul>
    </Menu>
    <p>{`Leave through top, `}<strong parentName="p">{`TALK TO BARBARA!`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "strip-d2-x"
      }}>{`Strip (d2 X)`}</h5>
      <ul>
        <li parentName="ul">{`Viki (d2 X2)`}</li>
        <li parentName="ul">{`Wakaba (l X2)`}</li>
      </ul>
      <h5 {...{
        "id": "withdraw-u-x"
      }}>{`Withdraw (u X)`}</h5>
      <ul>
        <li parentName="ul">{`Skill Ring > Nanami Slot 1 (3u X 2d X X)`}</li>
        <li parentName="ul">{`Magic Ring > Luc Slot 2 (X u X d X)`}</li>
      </ul>
    </Menu>
    <p>{`Teleport to Ryube (1D)`}</p>
    <h3 {...{
      "id": "ryube-forest-1"
    }}>{`Ryube Forest`}</h3>
    <p>{`Talk to Millie `}<strong parentName="p">{`Option 2`}</strong>{`, 1`}</p>
    <h4 {...{
      "id": "bonaparte-600hp"
    }}>{`Bonaparte (600HP)`}</h4>
    <p>{`Nanami Attack rest Defend`}</p>
    <p>{`Recruit `}<strong parentName="p">{`Kinnison & Shiro`}</strong>{`. Option 1, 1, `}<strong parentName="p">{`2`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Make sure you pick Option 2 at the end of recruitment so they don't join party.`}</strong></p>
    <p>{`Run to Mercenary Fort.`}</p>
    <h3 {...{
      "id": "mercenary-fort-5"
    }}>{`Mercenary Fort`}</h3>
    <p>{`Trigger Templeton Cutscene, head to Toto.`}</p>
    <h3 {...{
      "id": "toto-1"
    }}>{`Toto`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Templeton`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Run to Radat.`}</p>
    <h3 {...{
      "id": "radat-2"
    }}>{`Radat`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Amada`}</strong>{`, Option 1, 1.`}</p>
    <h4 {...{
      "id": "amada-duel-2-dies-to-1-wild--2-normal-attacks"
    }}>{`Amada Duel #2 (dies to 1 Wild / 2 normal attacks)`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Attack`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Defend`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Wild Attack`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Dammit!!! I might lose`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Argh! I'll get ya next`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ARGH!!!!.....`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Damn! Dammit!!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, boy, here`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, first a little`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`He he, first show me`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, it's my turn next!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ouch!!! I definitely`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I won't fall for that`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Way to go, kid!!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`Recruit `}<strong parentName="p">{`Yoshino`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Talk to Richmond Option 1, 1, 1, `}<strong parentName="p">{`2 after textbox when lose coinflip.`}</strong><br parentName="p"></br>{`
`}{`Go to pub & talk to bottom-right NPC.`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Stallion`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Richmond`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Head to Castle.`}</p>
    <h3 {...{
      "id": "castle-10"
    }}>{`Castle`}</h3>
    <p>{`Trigger Sheena`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Take elevator to 2nd floor, make sure there are 5 floors!`}</strong><br parentName="p"></br>{`
`}{`Sheena form an alliance `}<strong parentName="p">{`Option 2`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Teleport to Radat (3U), head to Banner Village.`}</p>
    <h3 {...{
      "id": "radat--banner-village"
    }}>{`Radat > Banner Village`}</h3>
    <p>{`Optionally go to inn to Save. You can then Soft Reset for Rose Brooch.`}<br parentName="p"></br>{`
`}{`If you end up soft resetting, can skip tossing items for Rune Unite Glitch.`}</p>
    <hr></hr>
    <p>{`Save at the inn before going to the Item Shop for Rose Brooch.`}</p>
    <hr></hr>
    <p>{`Go to Item Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-7"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`5`}</strong>{` Escape Talisman (For McDohl sidequest)`}</li>
        <li parentName="ul">{`Rose Brooch (if available, if not need to soft reset or come back later.)`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "banner-pass"
    }}>{`Banner Pass`}</h3>
    <p>{`Note Nanami's HP before Worm.`}</p>
    <h4 {...{
      "id": "worm-4200hp"
    }}>{`Worm (4200HP)`}</h4>
    <h5 {...{
      "id": "turn-1-7"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Defend`}</li>
      <li parentName="ul">{`Nanami: Shift`}</li>
      <li parentName="ul">{`Luc: Defend`}</li>
      <li parentName="ul">{`Millie: Defend`}</li>
      <li parentName="ul">{`Amada: Defend / Chirashi-Zushi Nanami if she's under 180HP on Turn 1`}</li>
      <li parentName="ul">{`Freed: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-6"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Nanami: Shift / Defend if Worm did Lightning T1`}</li>
      <li parentName="ul">{`Rest: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Nanami: Attack`}</li>
    </ul>
    <p>{`On final screen (screen after screen after Worm) `}<strong parentName="p">{`Escape Talisman`}</strong></p>
    <h3 {...{
      "id": "gregminster"
    }}>{`Gregminster`}</h3>
    <p><strong parentName="p"><em parentName="strong">{`When Sheena asks which girl Option 2 to get Kasumi`}</em></strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-4"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Add Kasumi to party > replace Amada.`}</li>
      </ul>
    </Menu>
    <p>{`Re-enter Gregminster.`}</p>
    <h3 {...{
      "id": "gregminster-1"
    }}>{`Gregminster`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Lorelai`}</strong>{`, Option 1, `}<strong parentName="p">{`Option 2`}</strong>{` to not add to party.`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Gordon`}</strong>{`, Option 2, then talk to him again.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "trade-shop"
      }}>{`Trade Shop`}</h5>
      <ul>
        <li parentName="ul">{`Buy `}<strong parentName="li">{`Celadon Urn`}</strong></li>
      </ul>
    </Menu>
    <p>{`Exit Gregminster & head to Rokkaku.`}</p>
    <h3 {...{
      "id": "rokkaku"
    }}>{`Rokkaku`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Mondo`}</strong>{`, Option 1. Replace Millie.`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Sasuke`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`You can setup Rune Unite SPD Glitch anytime between now & the Luca Fight.`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Toss Bandana & Robe to trigger RU Speed Glitch`}</strong><br parentName="p"></br>{`
`}{`If you got a Hazy Crystal from Kyaro Soldiers & equipped Friendship toss all Gloves in inventory as well.`}<br parentName="p"></br>{`
`}{`If you soft reset for Anita toss Tunic, don't toss Gloves.`}<br parentName="p"></br>{`
`}{`If you soft reset in Banner don't toss anything.`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "inventory-1"
      }}>{`Inventory`}</h5>
      <p>{`Toss stuff for Rune Unite glitch. With standard Bandanna & Robe shouldn't need to do anything.`}</p>
      <blockquote>
        <p parentName="blockquote">{`Final Relevant equipment should be:`}<br parentName="p"></br>{`
`}{`Riou: Ninja Suit, Winged Boots, Shredding x2, Fire Emblem`}<br parentName="p"></br>{`
`}{`Nanami: Karate Uniform, Skill Ring, Jizo (optional)`}<br parentName="p"></br>{`
`}{`Luc: Magic Ring, Speed Ring`}</p>
      </blockquote>
      <h5 {...{
        "id": "equipment-5"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Kasumi: Ninja Suit > Riou Robe (l X)`}</li>
        <li parentName="ul">{`Kasumi: Remove Bolt of Wrath x2`}</li>
        <li parentName="ul">{`Kasumi: Speed Ring > Luc Slot 3 (2r 2d X)`}</li>
        <li parentName="ul">{`Kasumi: Winged Boots > Hero Slot 1 (r X)`}</li>
        <li parentName="ul">{`Mondo: Remove Ninja Suit`}</li>
        <li parentName="ul">{`Mondo: Shredding x2 > Riou Slot 2 (r d X)`}</li>
        <li parentName="ul">{`Mondo: Jizo > Nanami (r u X) `}<em parentName="li">{`Optional`}</em></li>
      </ul>
    </Menu>
    <p>{`Leave Banner.`}</p>
    <h3 {...{
      "id": "castle-11"
    }}>{`Castle`}</h3>
    <p>{`Exit & Blinking Mirror.`}</p>
    <p>{`Great Hall > Talk to Nanami > Great Hall`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "ridley-capture-war-battle"
    }}>{`Ridley Capture War Battle`}</h3>
    <h5 {...{
      "id": "turn-1-8"
    }}>{`Turn 1`}</h5>
    <p>{`Ridley 1R Attack unit above him (automatically selected) or Wait`}</p>
    <h5 {...{
      "id": "turn-2--on"
    }}>{`Turn 2 & on`}</h5>
    <ul>
      <li parentName="ul">{`Flik: Fire Spear Hero `}<em parentName="li">{`Flik is to the right of Hero`}</em></li>
      <li parentName="ul">{`Gilbert: Invention Hero `}<em parentName="li">{`Viktor is below Hero, Gilbert is bottom right of Hero`}</em></li>
    </ul>
    <p>{`Go to bed (5th floor), Tsai `}<strong parentName="p">{`Option 2`}</strong>{`.`}</p>
    <hr></hr>
    <p>{`Save before starting this battle. Alternatively, save after this battle.`}</p>
    <hr></hr>
    <p><strong parentName="p">{`Option 2`}</strong>{` to start battle.`}</p>
    <h3 {...{
      "id": "luca-war-battle"
    }}>{`Luca War Battle`}</h3>
    <h5 {...{
      "id": "turn-1-9"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Riou: Move Right, Lightning Luca`}</li>
      <li parentName="ul">{`Flik (2 * R1): Fire Spear Luca`}</li>
      <li parentName="ul">{`Gilbert: Move Down, Invention Luca`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-7"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Flik (2 * R1) Fire Spear Luca`}</li>
    </ul>
    <h3 {...{
      "id": "castle-12"
    }}>{`Castle`}</h3>
    <p>{`1st Floor to trigger scene (Run close to Luc before going down to save ~1s)`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` to kick Luca's ass`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "hero-1"
      }}>{`Hero`}</h5>
      <ul>
        <li parentName="ul">{`Nanami (r d2)`}</li>
        <li parentName="ul">{`Meg (r3 d2)`}</li>
        <li parentName="ul">{`Luc (r)`}</li>
      </ul>
      <h5 {...{
        "id": "formation-6"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Nanami > Luc`}</li>
      </ul>
    </Menu>
    <p>{`Skip Flik & Viktor.`}<br parentName="p"></br>{`
`}{`After party selection `}<em parentName="p">{`Shu talks`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "viktor--flik-parties"
    }}>{`Viktor & Flik parties`}</h4>
    <p>{`Auto`}</p>
    <h4 {...{
      "id": "luca-hero-6500hp"
    }}>{`Luca Hero (6500HP)`}</h4>
    <h5 {...{
      "id": "turn-1-10"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Thor Shot`}</li>
      <li parentName="ul">{`Luc: Empty World`}</li>
      <li parentName="ul">{`Meg: Defend`}</li>
      <li parentName="ul">{`Nanami: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-8"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Family Attack`}</li>
    </ul>
    <p>{`Watch Luc Speed, needs 132 to always outspeed Whitewolves.`}</p>
    <p><strong parentName="p">{`2 Whitewolves Battles`}</strong><br parentName="p"></br>{`
`}{`Luc Shredding`}</p>
    <h5 style={{
      color: 'red',
      fontSize: '36px'
    }}>
  Menu after 2nd fight! Won't have a good opportunity to take Speed Ring later.
    </h5>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-6"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Meg: Best Equip`}</li>
        <li parentName="ul">{`Meg: Remove French Toast`}</li>
        <li parentName="ul">{`Meg: Slot 3 > Luc's Speed Ring (r u X)`}</li>
        <li parentName="ul">{`Meg: Anchovy Pizza > Nanami's Skill Ring (2l X)`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "luca-duel-135hp"
    }}>{`Luca Duel (135HP)`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Attack`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Defend`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Wild Attack`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Fool!!! That can't`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pig!!!! Die!!!!!!!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`That's nothing!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ridiculous!!! You think`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pig!!!!! You dare to`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`You impertinent little`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You little punk...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`You little punk!!!`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "castle-13"
    }}>{`Castle`}</h3>
    <p>{`Go to 1st floor, run close to Luc before going down to save 1s`}<br parentName="p"></br>{`
`}{`Teleport to Kuskus (5D)`}</p>
    <h3 {...{
      "id": "kuskus-3"
    }}>{`Kuskus`}</h3>
    <p>{`After Culgan leave by boat and Blinking Mirror`}</p>
    <h3 {...{
      "id": "castle-14"
    }}>{`Castle`}</h3>
    <p><em parentName="p">{`Teresa talks`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-5"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Stallion (l d)`}</li>
        <li parentName="ul">{`Tsai (l)`}</li>
        <li parentName="ul">{`Meg (l d2)`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "muse-6"
    }}>{`Muse`}</h3>
    <p>{`After archers Jowy `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Viktor > Convoy`}</p>
    <p><strong parentName="p">{`6 Soldiers`}</strong><br parentName="p"></br>{`
`}{`Hero Shredding Scroll.`}</p>
    <p><em parentName="p">{`After Battle run to right wall, walk 1 step down, then run down. If done properly should skip battle at stairs. Walking exactly 1 step is necessary.`}</em></p>
    <h3 {...{
      "id": "castle-15"
    }}>{`Castle`}</h3>
    <p>{`Leave Castle then Blinking Mirror`}<br parentName="p"></br>{`
`}{`Trigger Shu cutscene`}<br parentName="p"></br>{`
`}{`Teleport to Ryube (d)`}</p>
    <h3 {...{
      "id": "ryube-2"
    }}>{`Ryube`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Tomo`}</strong>{`.`}</p>
    <h3 {...{
      "id": "castle-16"
    }}>{`Castle`}</h3>
    <p>{`Teleport to Castle (r u)`}<br parentName="p"></br>{`
`}{`Run left part of path, before curb, then up to trigger Koyu, `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Viktor `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Koyu to convoy`}<br parentName="p"></br>{`
`}{`Nanami `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Teleport to Two River (u), run to Kobold Village.`}</p>
    <h3 {...{
      "id": "kobold-village"
    }}>{`Kobold Village`}</h3>
    <p>{`Watch Hix & Tengaar cutscene then leave & run to Drakemouth.`}</p>
    <h3 {...{
      "id": "drakemouth"
    }}>{`Drakemouth`}</h3>
    <p>{`Gijimu Cutscene then run to Tigermouth`}</p>
    <h3 {...{
      "id": "tigermouth--tinto"
    }}>{`Tigermouth > Tinto`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Power Ring`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Blacksmith.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sharpen-1"
      }}>{`Sharpen`}</h5>
      <p>{`Hero > LVL13`}</p>
      <h5 {...{
        "id": "remove"
      }}>{`Remove`}</h5>
      <p>{`Nanami - Kindness`}</p>
      <h5 {...{
        "id": "attach-3"
      }}>{`Attach`}</h5>
      <p>{`Kindess > Meg`}</p>
    </Menu>
    <p>{`All dialogue options Option 1`}</p>
    <p>{`After the second time going to bed go to Nanami's room instead of your room.`}</p>
    <p>{`Before checking out mines recruit `}<strong parentName="p">{`Raura`}</strong>{`.`}</p>
    <h4 {...{
      "id": "neclord-fight"
    }}>{`Neclord Fight`}</h4>
    <h5 {...{
      "id": "turns-1-3"
    }}>{`Turns 1-3`}</h5>
    <p>{`Defend`}</p>
    <p>{`After Cutscene `}<strong parentName="p">{`Escape Talisman`}</strong></p>
    <h3 {...{
      "id": "crom"
    }}>{`Crom`}</h3>
    <p>{`Talk to Leona to change party.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-6"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Sheena (d)`}</li>
        <li parentName="ul">{`Chaco (l2 d2)`}</li>
        <li parentName="ul">{`Meg (l d2)`}</li>
      </ul>
    </Menu>
    <p>{`Kahn scene put `}<strong parentName="p">{`Kahn in convoy`}</strong></p>
    <p>{`Teleport to `}<strong parentName="p">{`South Window (u4)`}</strong></p>
    <h3 {...{
      "id": "south-window-2"
    }}>{`South Window`}</h3>
    <p>{`Run right, recruit `}<strong parentName="p">{`Max`}</strong>{`, Option 1`}<br parentName="p"></br>{`
`}{`Go to inn for Annallee Cutscene`}</p>
    <blockquote>
      <p parentName="blockquote">{`Can delay Annallee cutscene until after Neclord to save 21s IGT for Kindness at cost of 2s realtime.`}</p>
    </blockquote>
    <p>{`Go to Rune Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "remove-1"
      }}>{`Remove`}</h5>
      <ul>
        <li parentName="ul">{`Nanami: Violence`}</li>
      </ul>
      <h5 {...{
        "id": "attach-4"
      }}>{`Attach`}</h5>
      <ul>
        <li parentName="ul">{`Violence > Meg`}</li>
        <li parentName="ul">{`Water > Sheena`}</li>
      </ul>
    </Menu>
    <p>{`Talk to Killey, Option 1. `}<em parentName="p">{`Faster to talk from right.`}</em><br parentName="p"></br>{`
`}{`Teleport to Tigermouth (r u)`}</p>
    <h3 {...{
      "id": "tigermouth"
    }}>{`Tigermouth`}</h3>
    <p><strong parentName="p">{`Sierra Skip`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`Line up with bottom of wall to the left of Sierra.`}<br parentName="p"></br>{`
`}{`Run right until you bounce up off corner on top of right wall.`}<br parentName="p"></br>{`
`}{`Run up and talk to Sierra.`}</p>
    </blockquote>
    <h4 {...{
      "id": "sierra-2800hp"
    }}>{`Sierra (2800HP)`}</h4>
    <h5 {...{
      "id": "turn-1-11"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Attack`}</li>
      <li parentName="ul">{`Meg: Trick Rune`}</li>
    </ul>
    <p>{`Teleport to Crom (r u3)`}</p>
    <blockquote>
      <p parentName="blockquote">{`If no Rose Brooch & are on pace for Meg Kindness can go to Banner here (r d5)`}<br parentName="p"></br>{`
`}{`Want to wait 51m IGT before checking again, about 53m real time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "crom-1"
    }}>{`Crom`}</h3>
    <h4 {...{
      "id": "party-7"
    }}>{`Party`}</h4>
    <p>{`Nanami > Convoy`}<br parentName="p"></br>{`
`}{`Kahn > Party`}<br parentName="p"></br>{`
`}{`Sierra > Convoy`}</p>
    <p>{`Leave Crom through top left path, head to Tinto Mines.`}</p>
    <h3 {...{
      "id": "tinto-mines"
    }}>{`Tinto Mines`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Better to delay Master Garb pickup, since not all battles are Let Go's.`}</p>
    </blockquote>
    <p><strong parentName="p">{`Pick up Window Setting (right chest)`}</strong>{`.`}</p>
    <hr></hr>
    <p>{`Save in Ice Ramp Room`}</p>
    <hr></hr>
    <p>{`Heal if Meg took damage.`}</p>
    <h4 {...{
      "id": "golem-7500hp"
    }}>{`Golem (7500HP)`}</h4>
    <h5 {...{
      "id": "turn-1-12"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Defend`}</li>
      <li parentName="ul">{`Sheena: Shift`}</li>
      <li parentName="ul">{`Chaco: Defend`}</li>
      <li parentName="ul">{`Meg: Shift`}</li>
      <li parentName="ul">{`Viktor: Defend`}</li>
      <li parentName="ul">{`Kahn: Shift`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-9"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Meg Trick Rune`}</li>
      <li parentName="ul"><em parentName="li">{`If not Violenced, all Defend`}</em></li>
    </ul>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Meg Trick Rune`}</li>
    </ul>
    <p>{`Escape Talisman`}</p>
    <h3 {...{
      "id": "tinto"
    }}>{`Tinto`}</h3>
    <p>{`Zombie skip`}<br parentName="p"></br>{`
`}{`Take note of Sheena MGC, want 100.`}</p>
    <h5 {...{
      "id": "2-zombie-fights"
    }}>{`2 Zombie Fights`}</h5>
    <p>{`1st: Riou Shining Light`}<br parentName="p"></br>{`
`}{`2nd: Riou Shining Light, Chaco Take from Bag (2u X) - Bolt of Wrath x2 (X) `}<strong parentName="p">{`IF`}</strong>{` Sheena won't reach 100MGC.`}</p>
    <h4 {...{
      "id": "neclord-4500hp"
    }}>{`Neclord (4500HP)`}</h4>
    <h5 {...{
      "id": "turn-1-sheena-lvl4-spell--no-sheena-lvl4-spell"
    }}>{`Turn 1 (Sheena LVL4 Spell / No Sheena LVL4 Spell)`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Thor Shot / Attack`}</li>
      <li parentName="ul">{`Sheena: Silent Lake / Defend`}</li>
      <li parentName="ul">{`Chaco: Defend / Bolt of Wrath Scroll`}</li>
      <li parentName="ul">{`Meg: Trick Rune`}</li>
      <li parentName="ul">{`Viktor: Defend`}</li>
      <li parentName="ul">{`Kahn: Defend / Charm Arrow`}</li>
    </ul>
    <p>{`Recruit `}<strong parentName="p">{`Jess`}</strong>{`. Option 1, 1.`}<br parentName="p"></br>{`
`}{`Teleport to `}<strong parentName="p">{`Kobold Village (r d)`}</strong>{`.`}</p>
    <h3 {...{
      "id": "kobold-village-1"
    }}>{`Kobold Village`}</h3>
    <p>{`Hix replace Meg.`}<br parentName="p"></br>{`
`}{`Blinking Mirror.`}</p>
    <h3 {...{
      "id": "castle-17"
    }}>{`Castle`}</h3>
    <p><strong parentName="p">{`Trigger Killey Cutscene`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Teleport to South Window (u4).`}</p>
    <h3 {...{
      "id": "south-window-3"
    }}>{`South Window`}</h3>
    <p><strong parentName="p">{`Go to Item Shop for Hix quest. Go below wooden pillar, enter from bottom.`}</strong><br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Killey`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Gantetsu`}</strong>{`, replace `}<strong parentName="p">{`Kahn`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Annallee`}</strong>{`, Option 1, 1, `}<strong parentName="p">{`Talk to from left side, saves lots of time.`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`Annallee is about a 75s break.`}</p>
    </blockquote>
    <p>{`Teleport to Kobold Village (r d)`}</p>
    <h3 {...{
      "id": "kobold-village-2"
    }}>{`Kobold Village`}</h3>
    <p>{`Talk to Chief, teleport to Cave of the Wind (u2).`}</p>
    <h3 {...{
      "id": "cave-of-the-wind-1"
    }}>{`Cave of the Wind`}</h3>
    <p>{`Pick up item for quest.`}<br parentName="p"></br>{`
`}{`Teleport to Kobold Village (r d)`}</p>
    <h3 {...{
      "id": "kobold"
    }}>{`Kobold`}</h3>
    <p>{`Talk to Chief, teleport to Two River (u)`}</p>
    <h3 {...{
      "id": "two-river-3"
    }}>{`Two River`}</h3>
    <p>{`Go to Sewer.`}</p>
    <h5 style={{
      color: 'red',
      fontSize: '36px'
    }}>
  Recruit Sid.
    </h5>
    <p><strong parentName="p">{`Get Bell`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go through Sewer (faster)`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Bob`}</strong>{`, Option 1 to add should be very slightly faster (replace Gantetsu)`}</p>
    <p>{`Teleport to Kobold Village (r d)`}</p>
    <h3 {...{
      "id": "kobold-village-3"
    }}>{`Kobold Village`}</h3>
    <p>{`Finish quest.`}<br parentName="p"></br>{`
`}{`Forest forks: Left, Right, Right, Down.`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Yuzu`}</strong>{`.`}</p>
    <h3 {...{
      "id": "castle-18"
    }}>{`Castle`}</h3>
    <p>{`Go to Great Hall.`}<br parentName="p"></br>{`
`}{`Talk to Apple to rearrange units.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "army-formation-1"
      }}>{`Army Formation`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Annallee`}</strong>{` > Max`}</li>
        <li parentName="ul"><strong parentName="li">{`Flik`}</strong>{` 1st unit > (Luc) `}<strong parentName="li">{`Chaco`}</strong></li>
        <li parentName="ul"><strong parentName="li">{`Flik`}</strong>{` 2nd unit > `}<strong parentName="li">{`Templeton`}</strong></li>
      </ul>
    </Menu>
    <p>{`Go to bed (5th floor).`}<br parentName="p"></br>{`
`}{`Take the elevator to the 2nd floor & go to stairs to trigger the cutscene with Chaco.`}<br parentName="p"></br>{`
`}{`Go back to bed.`}</p>
    <h4 {...{
      "id": "lucia-1500hp"
    }}>{`Lucia (1500HP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Even if you counter T1, an attack won't do enough damage to kill T2.`}</p>
    </blockquote>
    <p>{`Thor Shot + Bolt of Wrath`}</p>
    <p>{`Option 1 then `}<strong parentName="p">{`Option 2`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`Option 1 here is incredibly important. It decides which battle you do.`}<br parentName="p"></br>{`
`}{`Greenhill battle is practically undoable.`}<br parentName="p"></br>{`
`}{`Waiting in Castle is slower than battle at border.`}</p>
    </blockquote>
    <p>{`Meeting Room `}<strong parentName="p">{`Option 2`}</strong>{` then Option 1`}</p>
    <h3 {...{
      "id": "greenhill-liberation-war-battle"
    }}>{`Greenhill Liberation War Battle`}</h3>
    <h5 {...{
      "id": "turn-1-13"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero - D`}</li>
      <li parentName="ul">{`Hauser (R1) - UL`}</li>
      <li parentName="ul">{`Teresa (R1) - U`}</li>
      <li parentName="ul">{`Viktor (R1) - 2L`}</li>
      <li parentName="ul">{`Gilbert (R1) - D`}</li>
      <li parentName="ul">{`Flik (R1) - U`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-10"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Hero - D`}</li>
      <li parentName="ul">{`Hauser (R1) - 2L`}</li>
      <li parentName="ul">{`Teresa (R1) - U`}</li>
      <li parentName="ul">{`Viktor (R1) - UL`}</li>
      <li parentName="ul">{`Gilbert (R1) - D`}</li>
      <li parentName="ul">{`Flik (R1) - U`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-3"
    }}>{`Turn 3`}</h5>
    <p>{`End Turn`}</p>
    <h5 {...{
      "id": "turn-4-1"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`If unit in range: Flik (R2) - U`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5--on"
    }}>{`Turn 5 & on`}</h5>
    <p><em parentName="p">{`If an enemy unit will get in attacking range move away. Shouldn't happen though`}</em><br parentName="p"></br>{`
`}{`End Turn`}</p>
    <h3 {...{
      "id": "greenhill-1"
    }}>{`Greenhill`}</h3>
    <p><em parentName="p">{`When Shin asks to come along.`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`When Teresa joins `}<strong parentName="p">{`don't change formation.`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-8"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Rina (r2 d3)`}</li>
        <li parentName="ul">{`Meg (r3 u2)`}</li>
        <li parentName="ul">{`Luc (r u2)`}</li>
        <li parentName="ul">{`Stallion (r2 d2)`}</li>
      </ul>
      <h5 {...{
        "id": "formation-7"
      }}>{`Formation`}</h5>
      <p>{`Stallion > Bottom-right Slot`}</p>
    </Menu>
    <p>{`1st soldier battle Riou Shredding Scroll.`}<br parentName="p"></br>{`
`}{`Next 3 Soldier Fights Luc Shredding.`}</p>
    <h4 {...{
      "id": "lucia-2-4700hp"
    }}>{`Lucia 2 (4700HP)`}</h4>
    <ul>
      <li parentName="ul">{`Hero: Attack`}</li>
      <li parentName="ul">{`Rina: Explosion`}</li>
      <li parentName="ul">{`Meg: Trick Rune`}</li>
      <li parentName="ul">{`Luc: Thor Shot Lucia`}</li>
      <li parentName="ul">{`Stallion: Defend`}</li>
    </ul>
    <p>{`Only need to heal if Meg isn't full HP (she doesn't get auto-healed after Neclord).`}</p>
    <hr></hr>
    <p>{`Save here`}</p>
    <hr></hr>
    <p>{`5th Soldier Fight Luc King's Road (If Luc MGC < 185, Meg Attack too)`}<br parentName="p"></br>{`
`}{`Skip 6th Soldier battle by running right and down, around the loading zone.`}</p>
    <h4 {...{
      "id": "bone-dragon-8900hp"
    }}>{`Bone Dragon (8900HP)`}</h4>
    <h5 {...{
      "id": "turn-1-14"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Meg Shift`}</li>
      <li parentName="ul">{`Rest Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-assumes-violenced"
    }}>{`Turn 2 (assumes Violenced)`}</h5>
    <ul>
      <li parentName="ul">{`Hero: `}<strong parentName="li">{`Take from Bag`}</strong>{` - Shredding x4`}</li>
      <li parentName="ul">{`Meg Trick Rune`}</li>
    </ul>
    <p>{`If not Violenced, Meg Attack, if needed heal with Stallion.`}</p>
    <h3 {...{
      "id": "castle-19"
    }}>{`Castle`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Option 2 is faster than Option 3.`}</p>
    </blockquote>
    <p><em parentName="p">{`Shu: "......" > Apple: "Hero, Jowy, ..." "Most of the..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "greenhill-2"
    }}>{`Greenhill`}</h3>
    <p>{`Go to Rune Shop`}</p>
    <Menu mdxType="Menu">
      <p><em parentName="p">{`Take note of how much money you have here.`}</em></p>
      <h5 {...{
        "id": "buy-8"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Kite (u X)`}</li>
      </ul>
      <h5 {...{
        "id": "attach-5"
      }}>{`Attach`}</h5>
      <ul>
        <li parentName="ul">{`Kite > Meg (d2 X)`}</li>
      </ul>
    </Menu>
    <h5 style={{
      color: 'red',
      fontSize: '36px'
    }}>
  Talk to Jude
    </h5>
    <blockquote>
      <p parentName="blockquote">{`On first forest screen, where Lucia is running up, don't load the next screen before her. You can skip loading the Jowy cutscene by going too fast.`}</p>
    </blockquote>
    <p>{`Watch cutscene w/ Lucia & Jowy.`}</p>
    <h5 style={{
      color: 'red',
      fontSize: '36px'
    }}>
  Talk to Jude if you didn't earlier.
    </h5>
    <h3 {...{
      "id": "muse-liberation-war-battle"
    }}>{`Muse Liberation War Battle`}</h3>
    <h5 {...{
      "id": "turn-1-15"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Flik (Manual d2 r) - Move 3 Right`}</li>
      <li parentName="ul">{`Max (Manual 2u l) - Move 2 Down, Encourage`}</li>
      <li parentName="ul">{`Flik (Manual r) - Move 3 Right, Wait`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-11"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`To select Flik, select Hauser (r d) then press R1`}</em></li>
      <li parentName="ul">{`Flik - Move 2/3 Right (don't move next to highland unit)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-4"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Flik - Move into Muse`}</li>
    </ul>
    <h3 {...{
      "id": "muse-7"
    }}>{`Muse`}</h3>
    <p>{`Viktor `}<strong parentName="p">{`to convoy`}</strong>{` say `}<strong parentName="p">{`no to change formation.`}</strong><br parentName="p"></br>{`
`}{`Don't change party.`}<br parentName="p"></br>{`
`}{`Formation: Swap Nanami & Meg (l X u X)`}</p>
    <h4 {...{
      "id": "golden-wolf-3500hp"
    }}>{`Golden Wolf (3500HP)`}</h4>
    <h5 {...{
      "id": "turn-1-16"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Attack`}</li>
      <li parentName="ul">{`Luc: Thor Shot`}</li>
      <li parentName="ul">{`Meg: Trick Rune`}</li>
    </ul>
    <h3 {...{
      "id": "castle-20"
    }}>{`Castle`}</h3>
    <p>{`Talk to Leona to change party.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-9"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Viktor (d)`}</li>
        <li parentName="ul">{`Wakaba (l2 u)`}</li>
        <li parentName="ul">{`Stallion (u2)`}</li>
        <li parentName="ul">{`Mukumuku (l2 d3)`}</li>
      </ul>
      <h5 {...{
        "id": "if-clive-met-early"
      }}>{`If Clive met early`}</h5>
      <ul>
        <li parentName="ul">{`Clive (u2)`}</li>
        <li parentName="ul">{`Viktor (d)`}</li>
        <li parentName="ul">{`Wakaba (l2 u2)`}</li>
        <li parentName="ul">{`Stallion (u3)`}</li>
        <li parentName="ul">{`Mukumuku (l2 d2)`}</li>
      </ul>
      <h5 {...{
        "id": "formation-8"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Viktor > Mukumuku`}</li>
      </ul>
    </Menu>
    <p>{`Teleport to Greenhill-Matilda Path (r d4)`}</p>
    <h3 {...{
      "id": "greenhill-matilda-path"
    }}>{`Greenhill-Matilda Path`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Badeux`}</strong><br parentName="p"></br>{`
`}{`Teleport to Forest Village (r d3)`}</p>
    <h3 {...{
      "id": "forest-village-1"
    }}>{`Forest Village`}</h3>
    <p><strong parentName="p">{`Get Clay`}</strong></p>
    <p>{`Recruit `}<strong parentName="p">{`Ayda & Feather`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Hero Shredding scroll the Griffins.`}</p>
    <p>{`Recruit `}<strong parentName="p">{`Connell`}</strong>{`, 2nd house from bottom-left.`}</p>
    <p>{`Teleport to Kuskus (d5)`}</p>
    <h3 {...{
      "id": "kuskus-4"
    }}>{`Kuskus`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Karen`}</strong>{` 1, 1, 1, 1 (T, S, C, X, T, X, C, S)`}</p>
    <blockquote>
      <p parentName="blockquote">{`After you get the correct moves you can do whatever you want. L1 and R1 are pretty fun :)`}</p>
    </blockquote>
    <p>{`Recruit `}<strong parentName="p">{`Tessai`}</strong><br parentName="p"></br>{`
`}{`Teleport to Greenhill (r d2)`}</p>
    <h3 {...{
      "id": "greenhill-3"
    }}>{`Greenhill`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Pico`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Jude`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Teleport to Radat (u3)`}</p>
    <h3 {...{
      "id": "radat-3"
    }}>{`Radat`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Lebrante`}</strong><br parentName="p"></br>{`
`}{`Teleport to Tigermouth (r u)`}</p>
    <h3 {...{
      "id": "tigermouth-1"
    }}>{`Tigermouth`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Georg`}</strong>{`, Option 2 to not add to party.`}<br parentName="p"></br>{`
`}{`Teleport to Tinto (r u4)`}</p>
    <h3 {...{
      "id": "tinto-1"
    }}>{`Tinto`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Alberto`}</strong>{` (Armor Shop)`}<br parentName="p"></br>{`
`}{`Run to Crom`}</p>
    <h3 {...{
      "id": "crom-2"
    }}>{`Crom`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`LCC`}</strong>{`, go to Inn to trigger.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Optimal movement is run up until lined up with top right shrub then right till a bit past center shrub.`}</p>
    </blockquote>
    <p>{`Recruit `}<strong parentName="p">{`Tenkou`}</strong>{` (House southeast of Chief’s house)`}<br parentName="p"></br>{`
`}{`Teleport to Radat (u3)`}</p>
    <blockquote>
      <p parentName="blockquote">{`If no Rose Brooch you can delay Simone, Hoi, Vincent till last.`}<br parentName="p"></br>{`
`}{`Want to wait 51m IGT, ~53m real time before last check.`}<br parentName="p"></br>{`
`}{`TP Banner is (r 5d)`}</p>
    </blockquote>
    <h3 {...{
      "id": "radat-4"
    }}>{`Radat`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Hoi`}</strong>{`.`}</p>
    <h5 style={{
      color: 'red',
      fontSize: '36px'
    }}>
  Careful with options here, can permanently miss Simone.
    </h5>
    <p>{`Recruit `}<strong parentName="p">{`Simone`}</strong>{`, `}<strong parentName="p">{`Option 2`}</strong>{`, `}<strong parentName="p">{`Option 3`}</strong>{`, replace Hoi.`}<br parentName="p"></br>{`
`}{`Leave screen to the left & re-enter.`}</p>
    <p>{`Recruit `}<strong parentName="p">{`Vincent`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`This is a recruit check. He won’t be here if you missed someone.`}</p>
    </blockquote>
    <p>{`Teleport to Crom (r u3)`}</p>
    <h3 {...{
      "id": "crom-3"
    }}>{`Crom`}</h3>
    <p>{`Run to Tinto Mines`}</p>
    <h3 {...{
      "id": "tinto-mines-1"
    }}>{`Tinto Mines`}</h3>
    <p><strong parentName="p">{`Recruit Abizboah`}</strong><br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Master Garb`}</strong><br parentName="p"></br>{`
`}{`Recruit `}<strong parentName="p">{`Mazus`}</strong><br parentName="p"></br>{`
`}{`Escape Talisman`}</p>
    <p>{`Teleport to Cave of the Wind (u2)`}</p>
    <h3 {...{
      "id": "cave-of-the-wind-2"
    }}>{`Cave of the Wind`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Pesmerga`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`IMPORTANT, Put Pesmerga in party`}</strong></p>
    <hr></hr>
    <p>{`Save with save point at Cave entrance`}</p>
    <hr></hr>
    <p>{`Blinking Mirror`}</p>
    <h3 {...{
      "id": "castle-21"
    }}>{`Castle`}</h3>
    <p>{`Go to dock take boat to Coronet`}</p>
    <h3 {...{
      "id": "coronet-1"
    }}>{`Coronet`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Genshu`}</strong>{` Option 1, `}<strong parentName="p">{`Option 2`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Blinking Mirror.`}</p>
    <h3 {...{
      "id": "castle-22"
    }}>{`Castle`}</h3>
    <p>{`Go to 4th floor to watch Kiba Shu cutscene`}<br parentName="p"></br>{`
`}{`Talk to Shu Option 1`}</p>
    <p>{`Great Hall just mash > After Kiba cutscenes leave and Blinking Mirror`}<br parentName="p"></br>{`
`}{`Go to Great Hall `}<em parentName="p">{`Shu 1 textbox`}</em>{` `}<strong parentName="p">{`Option 2`}</strong>{` to start battle.`}</p>
    <h3 {...{
      "id": "rockaxe-war-battle"
    }}>{`Rockaxe War Battle`}</h3>
    <h5 {...{
      "id": "turn-1-17"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Viktor (R1) - R`}</li>
      <li parentName="ul">{`Kasumi (Manual) - D`}</li>
      <li parentName="ul">{`Teresa (Manual) - L`}</li>
      <li parentName="ul">{`Ayda (Manual) - 2L`}</li>
    </ul>
    <h5 {...{
      "id": "turns-2--3"
    }}>{`Turns 2 & 3`}</h5>
    <p>{`End Turn`}</p>
    <h3 {...{
      "id": "rockaxe-1"
    }}>{`Rockaxe`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-10"
      }}>{`Party`}</h5>
      <p>{`No Change`}</p>
      <h5 {...{
        "id": "formation-9"
      }}>{`Formation`}</h5>
      <p>{`Hero > Nanami (So 1 less click for Shredding Scroll)`}</p>
    </Menu>
    <p>{`Kill both forced battles with Shredding Scrolls. Make sure you have 1 left after!`}</p>
    <p>{`Fork (`}<strong parentName="p">{`LEFT`}</strong>{` right)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`LADDER`}</strong>{` up)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`RIGHT`}</strong>{` down)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`UP`}</strong>{` ladder)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`LADDER`}</strong>{` right)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`RIGHT`}</strong>{` down)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`LEFT`}</strong>{` up)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`RIGHT`}</strong>{` down)`}</p>
    <p><strong parentName="p">{`SELECT AN OPTION FOR NANAMI`}</strong>{`.`}</p>
    <h4 {...{
      "id": "gorudo-4500hp"
    }}>{`Gorudo (4500HP)`}</h4>
    <h5 {...{
      "id": "turn-1-18"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Forgiver's Sign`}</li>
      <li parentName="ul">{`Jowy: Hungry Friend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-12"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Defend`}</li>
      <li parentName="ul">{`Jowy: Hungry Friend`}</li>
    </ul>
    <h3 {...{
      "id": "castle-23"
    }}>{`Castle`}</h3>
    <blockquote>
      <p parentName="blockquote">{`You have 30 seconds before the cutscene triggers.`}</p>
    </blockquote>
    <p><em parentName="p">{`Move up 3 steps then 1 down (optimal position for cutscene), lines up with Rina`}</em></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Toss items that show up before Shredding in Take from Bag menu.`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-7"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Equip Master Garb`}</li>
        <li parentName="ul">{`Equip Power Ring`}</li>
      </ul>
      <p><em parentName="p">{`Equipment should be Master Garb, Fire Emblem, Winged Boots, and Power Ring.`}</em></p>
    </Menu>
    <p>{`When you wake up, after fade in you can move instantly so hold left to leave bed.`}</p>
    <p>{`Go to Great Hall, talk to Shu.`}<br parentName="p"></br>{`
`}{`After delay between textboxes, `}<em parentName="p">{`"Lord Hero, Give us the order to invade Highland."`}</em>{` `}<strong parentName="p">{`Option 3`}</strong></p>
    <p>{`After waking up leave room and go 4th floor to trigger Apple and Shu cutscene.`}<br parentName="p"></br>{`
`}{`Go back to bed, then Great Hall.`}</p>
    <p><em parentName="p">{`Shu 1 textbox`}</em>{` then `}<strong parentName="p">{`Option 2`}</strong></p>
    <p><em parentName="p">{`~30 second break between Hero "We're off!!! To L'Renouille!!!" and next input`}</em></p>
    <h3 {...{
      "id": "shu-war-battle"
    }}>{`Shu War Battle`}</h3>
    <p>{`No control, make sure Viktor has no activatable abilities like Fire Spear`}<br parentName="p"></br>{`
`}{`~1 minute break after Leon "He's not man enough to risk his own life."`}</p>
    <hr></hr>
    <p>{`Ask for McDohl and Clive incentives here`}</p>
    <hr></hr>
    <h3 {...{
      "id": "muse-highland-border-1"
    }}>{`Muse-Highland Border`}</h3>
    <p>{`Viktor "Are ya ready yet?" Talk to Apple then `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "lrenouille-war-battle"
    }}>{`L'Renouille War Battle`}</h3>
    <h5 {...{
      "id": "turns-1"
    }}>{`Turns 1`}</h5>
    <ul>
      <li parentName="ul">{`Flik (Manual u r2) - Move 2 Up 1 Right`}</li>
      <li parentName="ul">{`Max (Manual l2) - Move 1 Right, Encourage`}</li>
      <li parentName="ul">{`Flik (Manual r) - Move 3 Right`}</li>
    </ul>
    <h5 {...{
      "id": "turns-2-4"
    }}>{`Turns 2-4`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`To select Flik, select Hauser (u) then press R1`}</em></li>
      <li parentName="ul">{`Flik - Run into L'Renouille from left side.`}</li>
    </ul>
    <h3 {...{
      "id": "lrenouille"
    }}>{`L'Renouille`}</h3>
    <hr></hr>
    <p>{`This whole segment of the notes is for Clive and McDohl sidequests.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-11"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Clive (u2)`}</li>
        <li parentName="ul">{`Kasumi (l u)`}</li>
        <li parentName="ul">{`Mazus (l2 d2)`}</li>
        <li parentName="ul">{`Luc (l)`}</li>
        <li parentName="ul">{`Meg (l2)`}</li>
      </ul>
      <h5 {...{
        "id": "formation-10"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Hero > Mazus (X d X)`}</li>
        <li parentName="ul">{`Kasumi > Clive`}</li>
      </ul>
    </Menu>
    <p>{`Blinking Mirror. Teleport to Muse (d5)`}</p>
    <h3 {...{
      "id": "muse-8"
    }}>{`Muse`}</h3>
    <p>{`Set Text Speed to Slow`}<br parentName="p"></br>{`
`}{`Go to Jowston Hill for Clive Quest`}<br parentName="p"></br>{`
`}{`Blinking Mirror, Teleport to L'Renouille (r2 u2)`}<br parentName="p"></br>{`
`}{`Run to Sajah Village.`}</p>
    <h3 {...{
      "id": "sajah-village"
    }}>{`Sajah Village`}</h3>
    <p>{`Watch Clive Quest`}</p>
    <p>{`Set text speed to Fast`}</p>
    <p>{`Blinking Mirror, Teleport to Banner Village (r2 d3)`}</p>
    <h3 {...{
      "id": "banner-village"
    }}>{`Banner Village`}</h3>
    <p>{`Go to Gremio. Talk to Ko, Option 1.`}<br parentName="p"></br>{`
`}{`Go to Gremio. Talk to McDohl.`}</p>
    <p>{`McDohl replace Clive (Slot 3). Don't change formation.`}</p>
    <p>{`Go to Banner Pass. Talk to Ko's body.`}</p>
    <h4 {...{
      "id": "worm-2800hp"
    }}>{`Worm 2800HP`}</h4>
    <ul>
      <li parentName="ul">{`Mazus: Thunder Storm`}</li>
      <li parentName="ul">{`Riou: Attack`}</li>
      <li parentName="ul">{`Meg: Attack`}</li>
    </ul>
    <h4 {...{
      "id": "poison-moth-6800hp"
    }}>{`Poison Moth 6800HP`}</h4>
    <ul>
      <li parentName="ul">{`Mazus: Explosion`}</li>
      <li parentName="ul">{`McDohl: Judgement`}</li>
      <li parentName="ul">{`Riou: Attack`}</li>
      <li parentName="ul">{`Luc: Thor Shot`}</li>
      <li parentName="ul">{`Meg: Trick Rune`}</li>
    </ul>
    <p>{`After the cutscene switch text speed to Slow.`}<br parentName="p"></br>{`
`}{`Run to Varkas.`}</p>
    <p>{`After meeting with Lepant, leave the palace.`}<br parentName="p"></br>{`
`}{`After leaving McDohl's house, go to Palace. Option 1.`}<br parentName="p"></br>{`
`}{`Go south to leave Banner Pass.`}</p>
    <p>{`Switch text speed to Fast, leave and Blinking Mirror.`}</p>
    <p>{`Go to the Tavern, talk to Leona.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-12"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Remove Kasumi`}</li>
        <li parentName="ul">{`Flik (X)`}</li>
        <li parentName="ul">{`Sheena (d2)`}</li>
      </ul>
      <h5 {...{
        "id": "formation-11"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Riou > Sheena`}</li>
      </ul>
    </Menu>
    <p>{`Teleport to L'Renouille (r2 u2)`}</p>
    <p>{`Follow notes from Lucia 3 from here.`}</p>
    <hr></hr>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-13"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Sheena (d3)`}</li>
        <li parentName="ul">{`Flik (X)`}</li>
        <li parentName="ul">{`Meg (r5 u)`}</li>
        <li parentName="ul">{`Luc (r2 u2)`}</li>
        <li parentName="ul">{`Mazus (r u)`}</li>
      </ul>
      <h5 {...{
        "id": "formation-12"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Hero > Mazus (X l X)`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "lucia-6600hp"
    }}>{`Lucia (6600HP)`}</h4>
    <h5 {...{
      "id": "turn-1-safe"
    }}>{`Turn 1 (Safe)`}</h5>
    <ul>
      <li parentName="ul">{`Mazus Blazing Camp`}</li>
      <li parentName="ul">{`Sheena Silent Lake`}</li>
      <li parentName="ul">{`Meg Trick Rune`}</li>
      <li parentName="ul">{`Luc Thor Shot`}</li>
      <li parentName="ul">{`Hero Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-1-less-safe"
    }}>{`Turn 1 (Less Safe)`}</h5>
    <ul>
      <li parentName="ul">{`Mazus Explosion`}</li>
      <li parentName="ul">{`Meg Trick Rune`}</li>
      <li parentName="ul">{`Luc Thor Shot`}</li>
      <li parentName="ul">{`Hero Thor Shot`}</li>
    </ul>
    <p><strong parentName="p">{`Have Luc Take from Bag Shredding in one of the forced battles.`}</strong><br parentName="p"></br>{`
`}{`All 8 Forced Battles Kite Rune. First 3 characters can shift for faster menuing.`}</p>
    <h4 {...{
      "id": "han-duel-500hp"
    }}>{`Han Duel (500HP)`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Attack`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Defend`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Wild Attack`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I should have avoided`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Let's bury our past`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`And now it's my turn.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Unf.... you like to`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Now feel my deadly sword.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ho ho ho....`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Well struck.... it`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Watch and learn, boy.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`I can't let you past`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You think you can beat`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`You think my sword has`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Very good, boy.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Heal before Seed & Culgan.`}</p>
    <hr></hr>
    <p>{`Save here`}</p>
    <hr></hr>
    <h4 {...{
      "id": "seed--culgan-4200hp--3800hp"
    }}>{`Seed & Culgan (4200HP & 3800HP)`}</h4>
    <h5 {...{
      "id": "turn-1-19"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Mazus: Blazing Camp Culgan`}</li>
      <li parentName="ul">{`Sheena: Silent Lake`}</li>
      <li parentName="ul">{`Flik: Thor Shot Seed`}</li>
      <li parentName="ul">{`Meg: Trick Rune Culgan`}</li>
      <li parentName="ul">{`Luc: Thor Shot Seed`}</li>
      <li parentName="ul">{`Hero: Attack Culgan`}</li>
    </ul>
    <p>{`Heal via Save Crystal before Beast Rune`}</p>
    <h4 {...{
      "id": "beast-rune"
    }}>{`Beast Rune`}</h4>
    <h5 {...{
      "id": "turn-1-20"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Mazus: Explosion`}</li>
      <li parentName="ul">{`Sheena: Silent Lake`}</li>
      <li parentName="ul">{`Flik: Thor Shot Right Head`}</li>
      <li parentName="ul">{`Meg: Trick Rune Right Head`}</li>
      <li parentName="ul">{`Luc: Thor Shot Right Leg`}</li>
      <li parentName="ul">{`Hero: Thor Shot Rune`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-13"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Sheena: Attack Right Head`}</li>
      <li parentName="ul">{`Flik: Defend / Mega Medicine Sheena if he's damaged`}</li>
      <li parentName="ul">{`Meg: Kite Rune`}</li>
      <li parentName="ul">{`Luc: Shredding Scroll`}</li>
      <li parentName="ul">{`Hero: Attack Left Head`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-5"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Meg: Attack Left Head`}</li>
      <li parentName="ul">{`Hero: Attack Left Head`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-2"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Sheena: Attack Left Head`}</li>
      <li parentName="ul">{`Flik: Attack Left Head`}</li>
      <li parentName="ul">{`Meg: Attack Left Head`}</li>
      <li parentName="ul">{`Hero: Attack Left Head`}</li>
    </ul>
    <h3 {...{
      "id": "castle-24"
    }}>{`Castle`}</h3>
    <p>{`Go to 1st floor, teleport to Kyaro (X) and run to Tenzan Pass.`}</p>
    <h3 {...{
      "id": "kyaro--tenzan-pass"
    }}>{`Kyaro > Tenzan Pass`}</h3>
    <p>{`Can remove Master Garb for potentially faster fight.`}<br parentName="p"></br>{`
`}{`Wild Attack when Jowy Defends, Defend when he attacks.`}</p>
    <p>{`Each duel ends after 3 turns if you never attacked, or once Riou is low enough HP if you did attack.`}<br parentName="p"></br>{`
`}{`I think it's best to only Defend on 1st duel, and pick appropriate option on 2nd duel.`}<br parentName="p"></br>{`
`}{`With Master Garb equipped, there's a chance 1st duel is a 4 turn with Wild Attack.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Defend`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Wild Attack`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Bad move..... Hero`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hero.....`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Here goes..... Hero`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Let's test your strength`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Just like the old days`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`That's Right..... Hero`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Let's finish this long`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This reminds me of`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Next it's my turn`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Try again! 0.......`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`That's right. That's`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`You're the leader`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Why won't you fight`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`.........`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Done 2 Textboxes after Nanami scene. Last text is "Take care of yourself, Hero."`}</p>
    <h3 {...{
      "id": "fin"
    }}>{`Fin`}</h3>
    <h3 {...{
      "id": "todo"
    }}>{`TODO`}</h3>
    <ul>
      <li parentName="ul">{`Clive Sidequest Timing, see if we can do medium text speed`}</li>
      <li parentName="ul">{`McDohl quest notes + timing`}</li>
      <li parentName="ul">{`Glitch Exhibition notes`}</li>
    </ul>
    <h3 {...{
      "id": "savestates"
    }}>{`Savestates`}</h3>
    <ol {...{
      "start": 0
    }}>
      <li parentName="ol">{`Mist Monster Pre-equip`}</li>
      <li parentName="ol">{`Mist Monster Post-equip`}</li>
      <li parentName="ol">{`Kyaro Entrance`}</li>
      <li parentName="ol">{`Back at Fort`}</li>
      <li parentName="ol">{`Muse Entrance`}</li>
      <li parentName="ol">{`Ryube before equip menu`}</li>
      <li parentName="ol">{`Before Flik Duel`}</li>
      <li parentName="ol">{`Before War #1`}</li>
      <li parentName="ol">{`Before War #2`}</li>
      <li parentName="ol">{`Sindar Start`}</li>
      <li parentName="ol">{`Sindar Dam Close`}</li>
      <li parentName="ol">{`Sindar before Double Head`}</li>
      <li parentName="ol">{`Muse after inn`}</li>
      <li parentName="ol">{`Muse-Highland Border Entrance`}</li>
      <li parentName="ol">{`Muse-Highland Border Camp before entrance`}</li>
      <li parentName="ol">{`Muse-Highland Border after Jillia`}</li>
      <li parentName="ol">{`Muse after Inn`}</li>
      <li parentName="ol">{`Before Gilbert Battle`}</li>
      <li parentName="ol">{`Coronet Start`}</li>
      <li parentName="ol">{`Before Tai Ho`}</li>
      <li parentName="ol">{`South Window Start`}</li>
      <li parentName="ol">{`Cave of the Wind after Kahn joins`}</li>
      <li parentName="ol">{`Pre Abomination`}</li>
      <li parentName="ol">{`Pre Amada Duel`}</li>
      <li parentName="ol">{`Pre War Battle`}</li>
      <li parentName="ol">{`Pre Castle Name`}</li>
      <li parentName="ol">{`Pre Tai Ho`}</li>
      <li parentName="ol">{`Two River Start`}</li>
      <li parentName="ol">{`Pre Pest Rat & Menu`}</li>
      <li parentName="ol">{`Two River End`}</li>
      <li parentName="ol">{`Greenhill Party Selection`}</li>
      <li parentName="ol">{`Greenhill Entrance`}</li>
      <li parentName="ol">{`Greenhill Blacksmith`}</li>
      <li parentName="ol">{`Greenhill Exit`}</li>
      <li parentName="ol">{`Shilo`}</li>
      <li parentName="ol">{`Forest Village`}</li>
      <li parentName="ol">{`Before Refugees`}</li>
      <li parentName="ol">{`Highway Village Entrance`}</li>
      <li parentName="ol">{`Muse after Cutscene`}</li>
      <li parentName="ol">{`Rakutai Entrance`}</li>
      <li parentName="ol">{`Pre Harpy`}</li>
      <li parentName="ol">{`Castle Meeting Room after cutscene`}</li>
      <li parentName="ol">{`Castle pre War Battle`}</li>
      <li parentName="ol">{`Castle pre Kiba Battle`}</li>
      <li parentName="ol">{`Castle at Leona`}</li>
      <li parentName="ol">{`Banner Pass`}</li>
      <li parentName="ol">{`Worm`}</li>
      <li parentName="ol">{`Gregminster Re-visit`}</li>
      <li parentName="ol">{`Rokkaku post Sasuke pre menu`}</li>
      <li parentName="ol">{`Pre Ridley Battle`}</li>
      <li parentName="ol">{`Pre Luca War Battle`}</li>
      <li parentName="ol">{`Pre Luca Gauntlet`}</li>
      <li parentName="ol">{`After 2 Whitewolf Fights `}</li>
      <li parentName="ol">{`Castle post Luca`}</li>
      <li parentName="ol">{`Jowston Hill before forced battle`}</li>
      <li parentName="ol">{`Tinto`}</li>
      <li parentName="ol">{`Crom`}</li>
      <li parentName="ol">{`Drakemouth pre Sierra`}</li>
      <li parentName="ol">{`Pre Golem`}</li>
      <li parentName="ol">{`Zombie Skip`}</li>
      <li parentName="ol">{`Pre Neclord`}</li>
      <li parentName="ol">{`Kobold Village Entrance`}</li>
      <li parentName="ol">{`Great Hall before talking to Apple`}</li>
      <li parentName="ol">{`Great Hall before Greenhill War Battle`}</li>
      <li parentName="ol">{`Greenhill Party Menu`}</li>
      <li parentName="ol">{`Before Lucia 2`}</li>
      <li parentName="ol">{`Before Bone Dragon`}</li>
      <li parentName="ol">{`Before Muse Battle`}</li>
      <li parentName="ol">{`Castle after Muse`}</li>
      <li parentName="ol">{`Radat at Simone`}</li>
      <li parentName="ol">{`Before Rockaxe Battle`}</li>
      <li parentName="ol">{`Rockaxe Start`}</li>
      <li parentName="ol">{`Room before Gorudo`}</li>
      <li parentName="ol">{`Before L'Ren Battle`}</li>
      <li parentName="ol">{`L'Ren Party Menu`}</li>
      <li parentName="ol">{`Outside Sajah Village`}</li>
      <li parentName="ol">{`Banner Village`}</li>
      <li parentName="ol">{`Banner Pass before Worm`}</li>
      <li parentName="ol">{`Castle Leona party menu`}</li>
      <li parentName="ol">{`L'Ren before S&C`}</li>
      <li parentName="ol">{`L'Ren before Beast Rune`}</li>
      <li parentName="ol">{`Castle`}</li>
      <li parentName="ol">{`Tenzan Pass before duels`}</li>
    </ol>
    <h3 {...{
      "id": "glitch-exhibition"
    }}>{`Glitch Exhibition`}</h3>
    <h4 {...{
      "id": "1-2-north-sparrow-pass-escape-talisman"
    }}>{`(1-2) North Sparrow Pass Escape Talisman`}</h4>
    <ol>
      <li parentName="ol">{`Have guards not let you in, then Escape Talisman and run past them.`}</li>
      <li parentName="ol">{`Load next save and show lady's dialogue`}</li>
    </ol>
    <h4 {...{
      "id": "3-coronet-oob"
    }}>{`(3) Coronet OOB`}</h4>
    <ol>
      <li parentName="ol">{`Get on top of the roof/bookshelf, left up then right.`}</li>
      <li parentName="ol">{`10 steps left, then hold up`}</li>
      <li parentName="ol">{`Make sure to show Eilie's "I'm the person who saved RPGLB's life."`}</li>
    </ol>
    <h4 {...{
      "id": "4-hans-armor-glitch"
    }}>{`(4) Hans Armor Glitch`}</h4>
    <ol>
      <li parentName="ol">{`Load `}<strong parentName="li">{`Save 4`}</strong>{`:`}</li>
      <li parentName="ol">{`Buy Scalemail, select Riou`}</li>
      <li parentName="ol">{`Cancel sell or bag`}</li>
      <li parentName="ol">{`Buy for Flik`}</li>
      <li parentName="ol">{`Buy for Sheena`}</li>
      <li parentName="ol">{`Back out, should have 999999 potch`}</li>
    </ol>
    <h4 {...{
      "id": "4-castle-oob-glitch"
    }}>{`(4) Castle OOB Glitch`}</h4>
    <ol>
      <li parentName="ol">{`Continue from Hans save`}</li>
      <li parentName="ol">{`Run to bottom wall, go right. `}<strong parentName="li">{`WALK`}</strong>{` down to go OOB. `}</li>
      <li parentName="ol">{`Run around to relevant building`}</li>
      <li parentName="ol">{`Run into right wall for alignment.`}</li>
      <li parentName="ol">{`Run down step by step. Once visible for 2-3 steps, run up.`}</li>
      <li parentName="ol">{`Run to Radat`}</li>
    </ol>
    <h4 {...{
      "id": "5-matilda-glitch"
    }}>{`(5) Matilda Glitch`}</h4>
    <p>{`Push gate.`}</p>
    <h4 {...{
      "id": "6-damage-overflow-glitch"
    }}>{`(6) Damage Overflow Glitch`}</h4>
    <p><a parentName="p" {...{
        "href": "https://docs.google.com/spreadsheets/d/1LRXvBVz-SdhuWNXZrcVPgY4f1trrsJp-vzeKJLRFbOY/edit#gid=0"
      }}>{`Spreadsheet`}</a></p>
    <h5 {...{
      "id": "turn-2-14"
    }}>{`Turn 2`}</h5>
    <p>{`Servant Attack Bon Bon (Sleep). Does Real 18000 damage`}</p>
    <h5 {...{
      "id": "turn-3-6"
    }}>{`Turn 3`}</h5>
    <p>{`Servant Attack Bon Bon (Non-sleep). Shows heals for ~4000, real damage about 37000 heal.`}<br parentName="p"></br>{`
`}{`Stallion Sunomuno Bolgan.`}</p>
    <h5 {...{
      "id": "turn-4-3"
    }}>{`Turn 4`}</h5>
    <p>{`Servant Attack Bon Bon (Sleep) Damage shows 8544, Real damage is about 73000.`}<br parentName="p"></br>{`
`}{`Stallion Sunomuno Bob.`}</p>
    <h5 {...{
      "id": "turn-5--6"
    }}>{`Turn 5 & 6`}</h5>
    <p>{`Show that the BonBon doesn't die, hit it with party a few times.`}</p>
    <h4 {...{
      "id": "7-tenzan-pass-oob"
    }}>{`(7) Tenzan Pass OOB`}</h4>
    <h4 {...{
      "id": "8-tinto-oob"
    }}>{`(8) Tinto OOB`}</h4>
    <p>{`Talk to Imposter Miner`}</p>
    <h4 {...{
      "id": "9-two-river-kobold-oob"
    }}>{`(9) Two River Kobold OOB`}</h4>
    <h4 {...{
      "id": "10-banner-pass-oob"
    }}>{`(10) Banner Pass OOB`}</h4>
    <h4 {...{
      "id": "11-kyaro-cutscene-skip"
    }}>{`(11) Kyaro Cutscene Skip`}</h4>
    <p>{`Run into left wall then right wall`}</p>
    <h4 {...{
      "id": "12-lucia-greenhill-trigger"
    }}>{`(12) Lucia Greenhill Trigger`}</h4>
    <h4 {...{
      "id": "13-amada-early-recruitment-softlock"
    }}>{`(13) Amada early recruitment softlock`}</h4>
    <hr></hr>
    <h4 {...{
      "id": "saves-from-bottom-to-top"
    }}>{`Saves from bottom to top`}</h4>
    <ol>
      <li parentName="ol">{`North Sparrow Pass before glitch`}</li>
      <li parentName="ol">{`Kyaro next to army name lady`}</li>
      <li parentName="ol">{`Coronet after dock before Rikimaru`}</li>
      <li parentName="ol">{`Hans + Castle OOB Glitch`}</li>
      <li parentName="ol">{`Matilda Glitch`}</li>
      <li parentName="ol">{`Damage Overflow Glitch`}</li>
      <li parentName="ol">{`Tenzan OOB`}</li>
      <li parentName="ol">{`Tinto OOB`}</li>
      <li parentName="ol">{`Two River Kobold OOB`}</li>
      <li parentName="ol">{`Banner Pass OOB`}</li>
      <li parentName="ol">{`Kyaro Cutscene Skip`}</li>
      <li parentName="ol">{`Lucia Greenhill Trigger`}</li>
      <li parentName="ol">{`Amada post duel`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      